/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.ExpertRequest = (function() {

    /**
     * Properties of an ExpertRequest.
     * @exports IExpertRequest
     * @interface IExpertRequest
     * @property {string|null} [requestId] ExpertRequest requestId
     * @property {IEmpty|null} [endScan] ExpertRequest endScan
     * @property {IEmpty|null} [captureStill] ExpertRequest captureStill
     * @property {IEmpty|null} [startCaptureCine] ExpertRequest startCaptureCine
     * @property {IEmpty|null} [stopCaptureCine] ExpertRequest stopCaptureCine
     * @property {IEmpty|null} [cancelCaptureCine] ExpertRequest cancelCaptureCine
     * @property {ISetFreeze|null} [setFreeze] ExpertRequest setFreeze
     * @property {ISetImageOrientation|null} [setImageOrientation] ExpertRequest setImageOrientation
     * @property {ISetAugmentedRealityMode|null} [setAugmentedRealityMode] ExpertRequest setAugmentedRealityMode
     * @property {IInstruction|null} [sendInstruction] ExpertRequest sendInstruction
     * @property {IChangePreset|null} [changePreset] ExpertRequest changePreset
     * @property {IChangeMode|null} [changeMode] ExpertRequest changeMode
     * @property {IChangeDepth|null} [changeDepth] ExpertRequest changeDepth
     * @property {IChangeGain|null} [changeGain] ExpertRequest changeGain
     * @property {IShowMarker|null} [showMarker] ExpertRequest showMarker
     */

    /**
     * Constructs a new ExpertRequest.
     * @exports ExpertRequest
     * @classdesc Represents an ExpertRequest.
     * @implements IExpertRequest
     * @constructor
     * @param {IExpertRequest=} [properties] Properties to set
     */
    function ExpertRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ExpertRequest requestId.
     * @member {string} requestId
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.requestId = "";

    /**
     * ExpertRequest endScan.
     * @member {IEmpty|null|undefined} endScan
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.endScan = null;

    /**
     * ExpertRequest captureStill.
     * @member {IEmpty|null|undefined} captureStill
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.captureStill = null;

    /**
     * ExpertRequest startCaptureCine.
     * @member {IEmpty|null|undefined} startCaptureCine
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.startCaptureCine = null;

    /**
     * ExpertRequest stopCaptureCine.
     * @member {IEmpty|null|undefined} stopCaptureCine
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.stopCaptureCine = null;

    /**
     * ExpertRequest cancelCaptureCine.
     * @member {IEmpty|null|undefined} cancelCaptureCine
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.cancelCaptureCine = null;

    /**
     * ExpertRequest setFreeze.
     * @member {ISetFreeze|null|undefined} setFreeze
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.setFreeze = null;

    /**
     * ExpertRequest setImageOrientation.
     * @member {ISetImageOrientation|null|undefined} setImageOrientation
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.setImageOrientation = null;

    /**
     * ExpertRequest setAugmentedRealityMode.
     * @member {ISetAugmentedRealityMode|null|undefined} setAugmentedRealityMode
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.setAugmentedRealityMode = null;

    /**
     * ExpertRequest sendInstruction.
     * @member {IInstruction|null|undefined} sendInstruction
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.sendInstruction = null;

    /**
     * ExpertRequest changePreset.
     * @member {IChangePreset|null|undefined} changePreset
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.changePreset = null;

    /**
     * ExpertRequest changeMode.
     * @member {IChangeMode|null|undefined} changeMode
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.changeMode = null;

    /**
     * ExpertRequest changeDepth.
     * @member {IChangeDepth|null|undefined} changeDepth
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.changeDepth = null;

    /**
     * ExpertRequest changeGain.
     * @member {IChangeGain|null|undefined} changeGain
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.changeGain = null;

    /**
     * ExpertRequest showMarker.
     * @member {IShowMarker|null|undefined} showMarker
     * @memberof ExpertRequest
     * @instance
     */
    ExpertRequest.prototype.showMarker = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * ExpertRequest payload.
     * @member {"endScan"|"captureStill"|"startCaptureCine"|"stopCaptureCine"|"cancelCaptureCine"|"setFreeze"|"setImageOrientation"|"setAugmentedRealityMode"|"sendInstruction"|"changePreset"|"changeMode"|"changeDepth"|"changeGain"|"showMarker"|undefined} payload
     * @memberof ExpertRequest
     * @instance
     */
    Object.defineProperty(ExpertRequest.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["endScan", "captureStill", "startCaptureCine", "stopCaptureCine", "cancelCaptureCine", "setFreeze", "setImageOrientation", "setAugmentedRealityMode", "sendInstruction", "changePreset", "changeMode", "changeDepth", "changeGain", "showMarker"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ExpertRequest instance using the specified properties.
     * @function create
     * @memberof ExpertRequest
     * @static
     * @param {IExpertRequest=} [properties] Properties to set
     * @returns {ExpertRequest} ExpertRequest instance
     */
    ExpertRequest.create = function create(properties) {
        return new ExpertRequest(properties);
    };

    /**
     * Encodes the specified ExpertRequest message. Does not implicitly {@link ExpertRequest.verify|verify} messages.
     * @function encode
     * @memberof ExpertRequest
     * @static
     * @param {IExpertRequest} message ExpertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExpertRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
        if (message.endScan != null && message.hasOwnProperty("endScan"))
            $root.Empty.encode(message.endScan, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.captureStill != null && message.hasOwnProperty("captureStill"))
            $root.Empty.encode(message.captureStill, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.startCaptureCine != null && message.hasOwnProperty("startCaptureCine"))
            $root.Empty.encode(message.startCaptureCine, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.stopCaptureCine != null && message.hasOwnProperty("stopCaptureCine"))
            $root.Empty.encode(message.stopCaptureCine, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.cancelCaptureCine != null && message.hasOwnProperty("cancelCaptureCine"))
            $root.Empty.encode(message.cancelCaptureCine, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.setFreeze != null && message.hasOwnProperty("setFreeze"))
            $root.SetFreeze.encode(message.setFreeze, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.setImageOrientation != null && message.hasOwnProperty("setImageOrientation"))
            $root.SetImageOrientation.encode(message.setImageOrientation, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.setAugmentedRealityMode != null && message.hasOwnProperty("setAugmentedRealityMode"))
            $root.SetAugmentedRealityMode.encode(message.setAugmentedRealityMode, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.sendInstruction != null && message.hasOwnProperty("sendInstruction"))
            $root.Instruction.encode(message.sendInstruction, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.changePreset != null && message.hasOwnProperty("changePreset"))
            $root.ChangePreset.encode(message.changePreset, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.changeMode != null && message.hasOwnProperty("changeMode"))
            $root.ChangeMode.encode(message.changeMode, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.changeDepth != null && message.hasOwnProperty("changeDepth"))
            $root.ChangeDepth.encode(message.changeDepth, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
        if (message.changeGain != null && message.hasOwnProperty("changeGain"))
            $root.ChangeGain.encode(message.changeGain, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
        if (message.showMarker != null && message.hasOwnProperty("showMarker"))
            $root.ShowMarker.encode(message.showMarker, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ExpertRequest message, length delimited. Does not implicitly {@link ExpertRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ExpertRequest
     * @static
     * @param {IExpertRequest} message ExpertRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ExpertRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ExpertRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ExpertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ExpertRequest} ExpertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExpertRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ExpertRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.requestId = reader.string();
                break;
            case 3:
                message.endScan = $root.Empty.decode(reader, reader.uint32());
                break;
            case 4:
                message.captureStill = $root.Empty.decode(reader, reader.uint32());
                break;
            case 5:
                message.startCaptureCine = $root.Empty.decode(reader, reader.uint32());
                break;
            case 6:
                message.stopCaptureCine = $root.Empty.decode(reader, reader.uint32());
                break;
            case 7:
                message.cancelCaptureCine = $root.Empty.decode(reader, reader.uint32());
                break;
            case 8:
                message.setFreeze = $root.SetFreeze.decode(reader, reader.uint32());
                break;
            case 10:
                message.setImageOrientation = $root.SetImageOrientation.decode(reader, reader.uint32());
                break;
            case 11:
                message.setAugmentedRealityMode = $root.SetAugmentedRealityMode.decode(reader, reader.uint32());
                break;
            case 12:
                message.sendInstruction = $root.Instruction.decode(reader, reader.uint32());
                break;
            case 13:
                message.changePreset = $root.ChangePreset.decode(reader, reader.uint32());
                break;
            case 14:
                message.changeMode = $root.ChangeMode.decode(reader, reader.uint32());
                break;
            case 15:
                message.changeDepth = $root.ChangeDepth.decode(reader, reader.uint32());
                break;
            case 16:
                message.changeGain = $root.ChangeGain.decode(reader, reader.uint32());
                break;
            case 17:
                message.showMarker = $root.ShowMarker.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ExpertRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ExpertRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ExpertRequest} ExpertRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ExpertRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ExpertRequest message.
     * @function verify
     * @memberof ExpertRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ExpertRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isString(message.requestId))
                return "requestId: string expected";
        if (message.endScan != null && message.hasOwnProperty("endScan")) {
            properties.payload = 1;
            {
                var error = $root.Empty.verify(message.endScan);
                if (error)
                    return "endScan." + error;
            }
        }
        if (message.captureStill != null && message.hasOwnProperty("captureStill")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.Empty.verify(message.captureStill);
                if (error)
                    return "captureStill." + error;
            }
        }
        if (message.startCaptureCine != null && message.hasOwnProperty("startCaptureCine")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.Empty.verify(message.startCaptureCine);
                if (error)
                    return "startCaptureCine." + error;
            }
        }
        if (message.stopCaptureCine != null && message.hasOwnProperty("stopCaptureCine")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.Empty.verify(message.stopCaptureCine);
                if (error)
                    return "stopCaptureCine." + error;
            }
        }
        if (message.cancelCaptureCine != null && message.hasOwnProperty("cancelCaptureCine")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.Empty.verify(message.cancelCaptureCine);
                if (error)
                    return "cancelCaptureCine." + error;
            }
        }
        if (message.setFreeze != null && message.hasOwnProperty("setFreeze")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.SetFreeze.verify(message.setFreeze);
                if (error)
                    return "setFreeze." + error;
            }
        }
        if (message.setImageOrientation != null && message.hasOwnProperty("setImageOrientation")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.SetImageOrientation.verify(message.setImageOrientation);
                if (error)
                    return "setImageOrientation." + error;
            }
        }
        if (message.setAugmentedRealityMode != null && message.hasOwnProperty("setAugmentedRealityMode")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.SetAugmentedRealityMode.verify(message.setAugmentedRealityMode);
                if (error)
                    return "setAugmentedRealityMode." + error;
            }
        }
        if (message.sendInstruction != null && message.hasOwnProperty("sendInstruction")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.Instruction.verify(message.sendInstruction);
                if (error)
                    return "sendInstruction." + error;
            }
        }
        if (message.changePreset != null && message.hasOwnProperty("changePreset")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.ChangePreset.verify(message.changePreset);
                if (error)
                    return "changePreset." + error;
            }
        }
        if (message.changeMode != null && message.hasOwnProperty("changeMode")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.ChangeMode.verify(message.changeMode);
                if (error)
                    return "changeMode." + error;
            }
        }
        if (message.changeDepth != null && message.hasOwnProperty("changeDepth")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.ChangeDepth.verify(message.changeDepth);
                if (error)
                    return "changeDepth." + error;
            }
        }
        if (message.changeGain != null && message.hasOwnProperty("changeGain")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.ChangeGain.verify(message.changeGain);
                if (error)
                    return "changeGain." + error;
            }
        }
        if (message.showMarker != null && message.hasOwnProperty("showMarker")) {
            if (properties.payload === 1)
                return "payload: multiple values";
            properties.payload = 1;
            {
                var error = $root.ShowMarker.verify(message.showMarker);
                if (error)
                    return "showMarker." + error;
            }
        }
        return null;
    };

    /**
     * Creates an ExpertRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ExpertRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ExpertRequest} ExpertRequest
     */
    ExpertRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ExpertRequest)
            return object;
        var message = new $root.ExpertRequest();
        if (object.requestId != null)
            message.requestId = String(object.requestId);
        if (object.endScan != null) {
            if (typeof object.endScan !== "object")
                throw TypeError(".ExpertRequest.endScan: object expected");
            message.endScan = $root.Empty.fromObject(object.endScan);
        }
        if (object.captureStill != null) {
            if (typeof object.captureStill !== "object")
                throw TypeError(".ExpertRequest.captureStill: object expected");
            message.captureStill = $root.Empty.fromObject(object.captureStill);
        }
        if (object.startCaptureCine != null) {
            if (typeof object.startCaptureCine !== "object")
                throw TypeError(".ExpertRequest.startCaptureCine: object expected");
            message.startCaptureCine = $root.Empty.fromObject(object.startCaptureCine);
        }
        if (object.stopCaptureCine != null) {
            if (typeof object.stopCaptureCine !== "object")
                throw TypeError(".ExpertRequest.stopCaptureCine: object expected");
            message.stopCaptureCine = $root.Empty.fromObject(object.stopCaptureCine);
        }
        if (object.cancelCaptureCine != null) {
            if (typeof object.cancelCaptureCine !== "object")
                throw TypeError(".ExpertRequest.cancelCaptureCine: object expected");
            message.cancelCaptureCine = $root.Empty.fromObject(object.cancelCaptureCine);
        }
        if (object.setFreeze != null) {
            if (typeof object.setFreeze !== "object")
                throw TypeError(".ExpertRequest.setFreeze: object expected");
            message.setFreeze = $root.SetFreeze.fromObject(object.setFreeze);
        }
        if (object.setImageOrientation != null) {
            if (typeof object.setImageOrientation !== "object")
                throw TypeError(".ExpertRequest.setImageOrientation: object expected");
            message.setImageOrientation = $root.SetImageOrientation.fromObject(object.setImageOrientation);
        }
        if (object.setAugmentedRealityMode != null) {
            if (typeof object.setAugmentedRealityMode !== "object")
                throw TypeError(".ExpertRequest.setAugmentedRealityMode: object expected");
            message.setAugmentedRealityMode = $root.SetAugmentedRealityMode.fromObject(object.setAugmentedRealityMode);
        }
        if (object.sendInstruction != null) {
            if (typeof object.sendInstruction !== "object")
                throw TypeError(".ExpertRequest.sendInstruction: object expected");
            message.sendInstruction = $root.Instruction.fromObject(object.sendInstruction);
        }
        if (object.changePreset != null) {
            if (typeof object.changePreset !== "object")
                throw TypeError(".ExpertRequest.changePreset: object expected");
            message.changePreset = $root.ChangePreset.fromObject(object.changePreset);
        }
        if (object.changeMode != null) {
            if (typeof object.changeMode !== "object")
                throw TypeError(".ExpertRequest.changeMode: object expected");
            message.changeMode = $root.ChangeMode.fromObject(object.changeMode);
        }
        if (object.changeDepth != null) {
            if (typeof object.changeDepth !== "object")
                throw TypeError(".ExpertRequest.changeDepth: object expected");
            message.changeDepth = $root.ChangeDepth.fromObject(object.changeDepth);
        }
        if (object.changeGain != null) {
            if (typeof object.changeGain !== "object")
                throw TypeError(".ExpertRequest.changeGain: object expected");
            message.changeGain = $root.ChangeGain.fromObject(object.changeGain);
        }
        if (object.showMarker != null) {
            if (typeof object.showMarker !== "object")
                throw TypeError(".ExpertRequest.showMarker: object expected");
            message.showMarker = $root.ShowMarker.fromObject(object.showMarker);
        }
        return message;
    };

    /**
     * Creates a plain object from an ExpertRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ExpertRequest
     * @static
     * @param {ExpertRequest} message ExpertRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ExpertRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.requestId = "";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.endScan != null && message.hasOwnProperty("endScan")) {
            object.endScan = $root.Empty.toObject(message.endScan, options);
            if (options.oneofs)
                object.payload = "endScan";
        }
        if (message.captureStill != null && message.hasOwnProperty("captureStill")) {
            object.captureStill = $root.Empty.toObject(message.captureStill, options);
            if (options.oneofs)
                object.payload = "captureStill";
        }
        if (message.startCaptureCine != null && message.hasOwnProperty("startCaptureCine")) {
            object.startCaptureCine = $root.Empty.toObject(message.startCaptureCine, options);
            if (options.oneofs)
                object.payload = "startCaptureCine";
        }
        if (message.stopCaptureCine != null && message.hasOwnProperty("stopCaptureCine")) {
            object.stopCaptureCine = $root.Empty.toObject(message.stopCaptureCine, options);
            if (options.oneofs)
                object.payload = "stopCaptureCine";
        }
        if (message.cancelCaptureCine != null && message.hasOwnProperty("cancelCaptureCine")) {
            object.cancelCaptureCine = $root.Empty.toObject(message.cancelCaptureCine, options);
            if (options.oneofs)
                object.payload = "cancelCaptureCine";
        }
        if (message.setFreeze != null && message.hasOwnProperty("setFreeze")) {
            object.setFreeze = $root.SetFreeze.toObject(message.setFreeze, options);
            if (options.oneofs)
                object.payload = "setFreeze";
        }
        if (message.setImageOrientation != null && message.hasOwnProperty("setImageOrientation")) {
            object.setImageOrientation = $root.SetImageOrientation.toObject(message.setImageOrientation, options);
            if (options.oneofs)
                object.payload = "setImageOrientation";
        }
        if (message.setAugmentedRealityMode != null && message.hasOwnProperty("setAugmentedRealityMode")) {
            object.setAugmentedRealityMode = $root.SetAugmentedRealityMode.toObject(message.setAugmentedRealityMode, options);
            if (options.oneofs)
                object.payload = "setAugmentedRealityMode";
        }
        if (message.sendInstruction != null && message.hasOwnProperty("sendInstruction")) {
            object.sendInstruction = $root.Instruction.toObject(message.sendInstruction, options);
            if (options.oneofs)
                object.payload = "sendInstruction";
        }
        if (message.changePreset != null && message.hasOwnProperty("changePreset")) {
            object.changePreset = $root.ChangePreset.toObject(message.changePreset, options);
            if (options.oneofs)
                object.payload = "changePreset";
        }
        if (message.changeMode != null && message.hasOwnProperty("changeMode")) {
            object.changeMode = $root.ChangeMode.toObject(message.changeMode, options);
            if (options.oneofs)
                object.payload = "changeMode";
        }
        if (message.changeDepth != null && message.hasOwnProperty("changeDepth")) {
            object.changeDepth = $root.ChangeDepth.toObject(message.changeDepth, options);
            if (options.oneofs)
                object.payload = "changeDepth";
        }
        if (message.changeGain != null && message.hasOwnProperty("changeGain")) {
            object.changeGain = $root.ChangeGain.toObject(message.changeGain, options);
            if (options.oneofs)
                object.payload = "changeGain";
        }
        if (message.showMarker != null && message.hasOwnProperty("showMarker")) {
            object.showMarker = $root.ShowMarker.toObject(message.showMarker, options);
            if (options.oneofs)
                object.payload = "showMarker";
        }
        return object;
    };

    /**
     * Converts this ExpertRequest to JSON.
     * @function toJSON
     * @memberof ExpertRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ExpertRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ExpertRequest;
})();

$root.ShowMarker = (function() {

    /**
     * Properties of a ShowMarker.
     * @exports IShowMarker
     * @interface IShowMarker
     * @property {number|null} [markId] ShowMarker markId
     * @property {ShowMarker.Surface|null} [surface] ShowMarker surface
     * @property {boolean|null} [finished] ShowMarker finished
     * @property {Array.<ShowMarker.IPoint>|null} [points] ShowMarker points
     */

    /**
     * Constructs a new ShowMarker.
     * @exports ShowMarker
     * @classdesc Represents a ShowMarker.
     * @implements IShowMarker
     * @constructor
     * @param {IShowMarker=} [properties] Properties to set
     */
    function ShowMarker(properties) {
        this.points = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ShowMarker markId.
     * @member {number} markId
     * @memberof ShowMarker
     * @instance
     */
    ShowMarker.prototype.markId = 0;

    /**
     * ShowMarker surface.
     * @member {ShowMarker.Surface} surface
     * @memberof ShowMarker
     * @instance
     */
    ShowMarker.prototype.surface = 0;

    /**
     * ShowMarker finished.
     * @member {boolean} finished
     * @memberof ShowMarker
     * @instance
     */
    ShowMarker.prototype.finished = false;

    /**
     * ShowMarker points.
     * @member {Array.<ShowMarker.IPoint>} points
     * @memberof ShowMarker
     * @instance
     */
    ShowMarker.prototype.points = $util.emptyArray;

    /**
     * Creates a new ShowMarker instance using the specified properties.
     * @function create
     * @memberof ShowMarker
     * @static
     * @param {IShowMarker=} [properties] Properties to set
     * @returns {ShowMarker} ShowMarker instance
     */
    ShowMarker.create = function create(properties) {
        return new ShowMarker(properties);
    };

    /**
     * Encodes the specified ShowMarker message. Does not implicitly {@link ShowMarker.verify|verify} messages.
     * @function encode
     * @memberof ShowMarker
     * @static
     * @param {IShowMarker} message ShowMarker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowMarker.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.markId != null && message.hasOwnProperty("markId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.markId);
        if (message.surface != null && message.hasOwnProperty("surface"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.surface);
        if (message.finished != null && message.hasOwnProperty("finished"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.finished);
        if (message.points != null && message.points.length)
            for (var i = 0; i < message.points.length; ++i)
                $root.ShowMarker.Point.encode(message.points[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ShowMarker message, length delimited. Does not implicitly {@link ShowMarker.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ShowMarker
     * @static
     * @param {IShowMarker} message ShowMarker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ShowMarker.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ShowMarker message from the specified reader or buffer.
     * @function decode
     * @memberof ShowMarker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ShowMarker} ShowMarker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowMarker.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ShowMarker();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.markId = reader.int32();
                break;
            case 2:
                message.surface = reader.int32();
                break;
            case 3:
                message.finished = reader.bool();
                break;
            case 4:
                if (!(message.points && message.points.length))
                    message.points = [];
                message.points.push($root.ShowMarker.Point.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ShowMarker message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ShowMarker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ShowMarker} ShowMarker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ShowMarker.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ShowMarker message.
     * @function verify
     * @memberof ShowMarker
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ShowMarker.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.markId != null && message.hasOwnProperty("markId"))
            if (!$util.isInteger(message.markId))
                return "markId: integer expected";
        if (message.surface != null && message.hasOwnProperty("surface"))
            switch (message.surface) {
            default:
                return "surface: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.finished != null && message.hasOwnProperty("finished"))
            if (typeof message.finished !== "boolean")
                return "finished: boolean expected";
        if (message.points != null && message.hasOwnProperty("points")) {
            if (!Array.isArray(message.points))
                return "points: array expected";
            for (var i = 0; i < message.points.length; ++i) {
                var error = $root.ShowMarker.Point.verify(message.points[i]);
                if (error)
                    return "points." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ShowMarker message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ShowMarker
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ShowMarker} ShowMarker
     */
    ShowMarker.fromObject = function fromObject(object) {
        if (object instanceof $root.ShowMarker)
            return object;
        var message = new $root.ShowMarker();
        if (object.markId != null)
            message.markId = object.markId | 0;
        switch (object.surface) {
        case "UNKNOWN_SURFACE":
        case 0:
            message.surface = 0;
            break;
        case "PROBE":
        case 1:
            message.surface = 1;
            break;
        case "CAMERA":
        case 2:
            message.surface = 2;
            break;
        }
        if (object.finished != null)
            message.finished = Boolean(object.finished);
        if (object.points) {
            if (!Array.isArray(object.points))
                throw TypeError(".ShowMarker.points: array expected");
            message.points = [];
            for (var i = 0; i < object.points.length; ++i) {
                if (typeof object.points[i] !== "object")
                    throw TypeError(".ShowMarker.points: object expected");
                message.points[i] = $root.ShowMarker.Point.fromObject(object.points[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ShowMarker message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ShowMarker
     * @static
     * @param {ShowMarker} message ShowMarker
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ShowMarker.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.points = [];
        if (options.defaults) {
            object.markId = 0;
            object.surface = options.enums === String ? "UNKNOWN_SURFACE" : 0;
            object.finished = false;
        }
        if (message.markId != null && message.hasOwnProperty("markId"))
            object.markId = message.markId;
        if (message.surface != null && message.hasOwnProperty("surface"))
            object.surface = options.enums === String ? $root.ShowMarker.Surface[message.surface] : message.surface;
        if (message.finished != null && message.hasOwnProperty("finished"))
            object.finished = message.finished;
        if (message.points && message.points.length) {
            object.points = [];
            for (var j = 0; j < message.points.length; ++j)
                object.points[j] = $root.ShowMarker.Point.toObject(message.points[j], options);
        }
        return object;
    };

    /**
     * Converts this ShowMarker to JSON.
     * @function toJSON
     * @memberof ShowMarker
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ShowMarker.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ShowMarker.Point = (function() {

        /**
         * Properties of a Point.
         * @memberof ShowMarker
         * @interface IPoint
         * @property {number|null} [x] Point x
         * @property {number|null} [y] Point y
         */

        /**
         * Constructs a new Point.
         * @memberof ShowMarker
         * @classdesc Represents a Point.
         * @implements IPoint
         * @constructor
         * @param {ShowMarker.IPoint=} [properties] Properties to set
         */
        function Point(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Point x.
         * @member {number} x
         * @memberof ShowMarker.Point
         * @instance
         */
        Point.prototype.x = 0;

        /**
         * Point y.
         * @member {number} y
         * @memberof ShowMarker.Point
         * @instance
         */
        Point.prototype.y = 0;

        /**
         * Creates a new Point instance using the specified properties.
         * @function create
         * @memberof ShowMarker.Point
         * @static
         * @param {ShowMarker.IPoint=} [properties] Properties to set
         * @returns {ShowMarker.Point} Point instance
         */
        Point.create = function create(properties) {
            return new Point(properties);
        };

        /**
         * Encodes the specified Point message. Does not implicitly {@link ShowMarker.Point.verify|verify} messages.
         * @function encode
         * @memberof ShowMarker.Point
         * @static
         * @param {ShowMarker.IPoint} message Point message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Point.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.x != null && message.hasOwnProperty("x"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
            if (message.y != null && message.hasOwnProperty("y"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
            return writer;
        };

        /**
         * Encodes the specified Point message, length delimited. Does not implicitly {@link ShowMarker.Point.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ShowMarker.Point
         * @static
         * @param {ShowMarker.IPoint} message Point message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Point.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Point message from the specified reader or buffer.
         * @function decode
         * @memberof ShowMarker.Point
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ShowMarker.Point} Point
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Point.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ShowMarker.Point();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.x = reader.float();
                    break;
                case 2:
                    message.y = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Point message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ShowMarker.Point
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ShowMarker.Point} Point
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Point.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Point message.
         * @function verify
         * @memberof ShowMarker.Point
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Point.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.x != null && message.hasOwnProperty("x"))
                if (typeof message.x !== "number")
                    return "x: number expected";
            if (message.y != null && message.hasOwnProperty("y"))
                if (typeof message.y !== "number")
                    return "y: number expected";
            return null;
        };

        /**
         * Creates a Point message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ShowMarker.Point
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ShowMarker.Point} Point
         */
        Point.fromObject = function fromObject(object) {
            if (object instanceof $root.ShowMarker.Point)
                return object;
            var message = new $root.ShowMarker.Point();
            if (object.x != null)
                message.x = Number(object.x);
            if (object.y != null)
                message.y = Number(object.y);
            return message;
        };

        /**
         * Creates a plain object from a Point message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ShowMarker.Point
         * @static
         * @param {ShowMarker.Point} message Point
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Point.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.x = 0;
                object.y = 0;
            }
            if (message.x != null && message.hasOwnProperty("x"))
                object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
            if (message.y != null && message.hasOwnProperty("y"))
                object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
            return object;
        };

        /**
         * Converts this Point to JSON.
         * @function toJSON
         * @memberof ShowMarker.Point
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Point.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Point;
    })();

    /**
     * Surface enum.
     * @name ShowMarker.Surface
     * @enum {string}
     * @property {number} UNKNOWN_SURFACE=0 UNKNOWN_SURFACE value
     * @property {number} PROBE=1 PROBE value
     * @property {number} CAMERA=2 CAMERA value
     */
    ShowMarker.Surface = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SURFACE"] = 0;
        values[valuesById[1] = "PROBE"] = 1;
        values[valuesById[2] = "CAMERA"] = 2;
        return values;
    })();

    return ShowMarker;
})();

$root.ChangeGain = (function() {

    /**
     * Properties of a ChangeGain.
     * @exports IChangeGain
     * @interface IChangeGain
     * @property {number|null} [value] ChangeGain value
     * @property {boolean|null} [tentative] ChangeGain tentative
     */

    /**
     * Constructs a new ChangeGain.
     * @exports ChangeGain
     * @classdesc Represents a ChangeGain.
     * @implements IChangeGain
     * @constructor
     * @param {IChangeGain=} [properties] Properties to set
     */
    function ChangeGain(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ChangeGain value.
     * @member {number} value
     * @memberof ChangeGain
     * @instance
     */
    ChangeGain.prototype.value = 0;

    /**
     * ChangeGain tentative.
     * @member {boolean} tentative
     * @memberof ChangeGain
     * @instance
     */
    ChangeGain.prototype.tentative = false;

    /**
     * Creates a new ChangeGain instance using the specified properties.
     * @function create
     * @memberof ChangeGain
     * @static
     * @param {IChangeGain=} [properties] Properties to set
     * @returns {ChangeGain} ChangeGain instance
     */
    ChangeGain.create = function create(properties) {
        return new ChangeGain(properties);
    };

    /**
     * Encodes the specified ChangeGain message. Does not implicitly {@link ChangeGain.verify|verify} messages.
     * @function encode
     * @memberof ChangeGain
     * @static
     * @param {IChangeGain} message ChangeGain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeGain.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.tentative);
        return writer;
    };

    /**
     * Encodes the specified ChangeGain message, length delimited. Does not implicitly {@link ChangeGain.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ChangeGain
     * @static
     * @param {IChangeGain} message ChangeGain message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeGain.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChangeGain message from the specified reader or buffer.
     * @function decode
     * @memberof ChangeGain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChangeGain} ChangeGain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeGain.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeGain();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.float();
                break;
            case 2:
                message.tentative = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ChangeGain message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ChangeGain
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ChangeGain} ChangeGain
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeGain.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChangeGain message.
     * @function verify
     * @memberof ChangeGain
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChangeGain.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value !== "number")
                return "value: number expected";
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            if (typeof message.tentative !== "boolean")
                return "tentative: boolean expected";
        return null;
    };

    /**
     * Creates a ChangeGain message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChangeGain
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChangeGain} ChangeGain
     */
    ChangeGain.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeGain)
            return object;
        var message = new $root.ChangeGain();
        if (object.value != null)
            message.value = Number(object.value);
        if (object.tentative != null)
            message.tentative = Boolean(object.tentative);
        return message;
    };

    /**
     * Creates a plain object from a ChangeGain message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChangeGain
     * @static
     * @param {ChangeGain} message ChangeGain
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChangeGain.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.value = 0;
            object.tentative = false;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            object.tentative = message.tentative;
        return object;
    };

    /**
     * Converts this ChangeGain to JSON.
     * @function toJSON
     * @memberof ChangeGain
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChangeGain.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeGain;
})();

$root.ChangeDepth = (function() {

    /**
     * Properties of a ChangeDepth.
     * @exports IChangeDepth
     * @interface IChangeDepth
     * @property {number|null} [value] ChangeDepth value
     * @property {boolean|null} [tentative] ChangeDepth tentative
     */

    /**
     * Constructs a new ChangeDepth.
     * @exports ChangeDepth
     * @classdesc Represents a ChangeDepth.
     * @implements IChangeDepth
     * @constructor
     * @param {IChangeDepth=} [properties] Properties to set
     */
    function ChangeDepth(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ChangeDepth value.
     * @member {number} value
     * @memberof ChangeDepth
     * @instance
     */
    ChangeDepth.prototype.value = 0;

    /**
     * ChangeDepth tentative.
     * @member {boolean} tentative
     * @memberof ChangeDepth
     * @instance
     */
    ChangeDepth.prototype.tentative = false;

    /**
     * Creates a new ChangeDepth instance using the specified properties.
     * @function create
     * @memberof ChangeDepth
     * @static
     * @param {IChangeDepth=} [properties] Properties to set
     * @returns {ChangeDepth} ChangeDepth instance
     */
    ChangeDepth.create = function create(properties) {
        return new ChangeDepth(properties);
    };

    /**
     * Encodes the specified ChangeDepth message. Does not implicitly {@link ChangeDepth.verify|verify} messages.
     * @function encode
     * @memberof ChangeDepth
     * @static
     * @param {IChangeDepth} message ChangeDepth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeDepth.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.tentative);
        return writer;
    };

    /**
     * Encodes the specified ChangeDepth message, length delimited. Does not implicitly {@link ChangeDepth.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ChangeDepth
     * @static
     * @param {IChangeDepth} message ChangeDepth message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeDepth.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChangeDepth message from the specified reader or buffer.
     * @function decode
     * @memberof ChangeDepth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChangeDepth} ChangeDepth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeDepth.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeDepth();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.float();
                break;
            case 2:
                message.tentative = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ChangeDepth message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ChangeDepth
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ChangeDepth} ChangeDepth
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeDepth.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChangeDepth message.
     * @function verify
     * @memberof ChangeDepth
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChangeDepth.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value !== "number")
                return "value: number expected";
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            if (typeof message.tentative !== "boolean")
                return "tentative: boolean expected";
        return null;
    };

    /**
     * Creates a ChangeDepth message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChangeDepth
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChangeDepth} ChangeDepth
     */
    ChangeDepth.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeDepth)
            return object;
        var message = new $root.ChangeDepth();
        if (object.value != null)
            message.value = Number(object.value);
        if (object.tentative != null)
            message.tentative = Boolean(object.tentative);
        return message;
    };

    /**
     * Creates a plain object from a ChangeDepth message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChangeDepth
     * @static
     * @param {ChangeDepth} message ChangeDepth
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChangeDepth.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.value = 0;
            object.tentative = false;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
        if (message.tentative != null && message.hasOwnProperty("tentative"))
            object.tentative = message.tentative;
        return object;
    };

    /**
     * Converts this ChangeDepth to JSON.
     * @function toJSON
     * @memberof ChangeDepth
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChangeDepth.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeDepth;
})();

$root.ChangeMode = (function() {

    /**
     * Properties of a ChangeMode.
     * @exports IChangeMode
     * @interface IChangeMode
     * @property {ImagingMode|null} [value] ChangeMode value
     */

    /**
     * Constructs a new ChangeMode.
     * @exports ChangeMode
     * @classdesc Represents a ChangeMode.
     * @implements IChangeMode
     * @constructor
     * @param {IChangeMode=} [properties] Properties to set
     */
    function ChangeMode(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ChangeMode value.
     * @member {ImagingMode} value
     * @memberof ChangeMode
     * @instance
     */
    ChangeMode.prototype.value = 0;

    /**
     * Creates a new ChangeMode instance using the specified properties.
     * @function create
     * @memberof ChangeMode
     * @static
     * @param {IChangeMode=} [properties] Properties to set
     * @returns {ChangeMode} ChangeMode instance
     */
    ChangeMode.create = function create(properties) {
        return new ChangeMode(properties);
    };

    /**
     * Encodes the specified ChangeMode message. Does not implicitly {@link ChangeMode.verify|verify} messages.
     * @function encode
     * @memberof ChangeMode
     * @static
     * @param {IChangeMode} message ChangeMode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeMode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
        return writer;
    };

    /**
     * Encodes the specified ChangeMode message, length delimited. Does not implicitly {@link ChangeMode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ChangeMode
     * @static
     * @param {IChangeMode} message ChangeMode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangeMode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChangeMode message from the specified reader or buffer.
     * @function decode
     * @memberof ChangeMode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChangeMode} ChangeMode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeMode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangeMode();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ChangeMode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ChangeMode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ChangeMode} ChangeMode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangeMode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChangeMode message.
     * @function verify
     * @memberof ChangeMode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChangeMode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            switch (message.value) {
            default:
                return "value: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    /**
     * Creates a ChangeMode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChangeMode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChangeMode} ChangeMode
     */
    ChangeMode.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangeMode)
            return object;
        var message = new $root.ChangeMode();
        switch (object.value) {
        case "UNKNOWN_MODE":
        case 0:
            message.value = 0;
            break;
        case "B_MODE":
        case 1:
            message.value = 1;
            break;
        case "COLOR_DOPPLER":
        case 2:
            message.value = 2;
            break;
        case "POWER_DOPPLER":
        case 3:
            message.value = 3;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a ChangeMode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChangeMode
     * @static
     * @param {ChangeMode} message ChangeMode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChangeMode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.value = options.enums === String ? "UNKNOWN_MODE" : 0;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.enums === String ? $root.ImagingMode[message.value] : message.value;
        return object;
    };

    /**
     * Converts this ChangeMode to JSON.
     * @function toJSON
     * @memberof ChangeMode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChangeMode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangeMode;
})();

$root.ChangePreset = (function() {

    /**
     * Properties of a ChangePreset.
     * @exports IChangePreset
     * @interface IChangePreset
     * @property {string|null} [value] ChangePreset value
     */

    /**
     * Constructs a new ChangePreset.
     * @exports ChangePreset
     * @classdesc Represents a ChangePreset.
     * @implements IChangePreset
     * @constructor
     * @param {IChangePreset=} [properties] Properties to set
     */
    function ChangePreset(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ChangePreset value.
     * @member {string} value
     * @memberof ChangePreset
     * @instance
     */
    ChangePreset.prototype.value = "";

    /**
     * Creates a new ChangePreset instance using the specified properties.
     * @function create
     * @memberof ChangePreset
     * @static
     * @param {IChangePreset=} [properties] Properties to set
     * @returns {ChangePreset} ChangePreset instance
     */
    ChangePreset.create = function create(properties) {
        return new ChangePreset(properties);
    };

    /**
     * Encodes the specified ChangePreset message. Does not implicitly {@link ChangePreset.verify|verify} messages.
     * @function encode
     * @memberof ChangePreset
     * @static
     * @param {IChangePreset} message ChangePreset message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangePreset.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
        return writer;
    };

    /**
     * Encodes the specified ChangePreset message, length delimited. Does not implicitly {@link ChangePreset.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ChangePreset
     * @static
     * @param {IChangePreset} message ChangePreset message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ChangePreset.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ChangePreset message from the specified reader or buffer.
     * @function decode
     * @memberof ChangePreset
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ChangePreset} ChangePreset
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangePreset.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChangePreset();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ChangePreset message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ChangePreset
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ChangePreset} ChangePreset
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ChangePreset.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ChangePreset message.
     * @function verify
     * @memberof ChangePreset
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ChangePreset.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        return null;
    };

    /**
     * Creates a ChangePreset message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ChangePreset
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ChangePreset} ChangePreset
     */
    ChangePreset.fromObject = function fromObject(object) {
        if (object instanceof $root.ChangePreset)
            return object;
        var message = new $root.ChangePreset();
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    /**
     * Creates a plain object from a ChangePreset message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ChangePreset
     * @static
     * @param {ChangePreset} message ChangePreset
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ChangePreset.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.value = "";
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    /**
     * Converts this ChangePreset to JSON.
     * @function toJSON
     * @memberof ChangePreset
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ChangePreset.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ChangePreset;
})();

$root.SetFreeze = (function() {

    /**
     * Properties of a SetFreeze.
     * @exports ISetFreeze
     * @interface ISetFreeze
     * @property {boolean|null} [value] SetFreeze value
     */

    /**
     * Constructs a new SetFreeze.
     * @exports SetFreeze
     * @classdesc Represents a SetFreeze.
     * @implements ISetFreeze
     * @constructor
     * @param {ISetFreeze=} [properties] Properties to set
     */
    function SetFreeze(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SetFreeze value.
     * @member {boolean} value
     * @memberof SetFreeze
     * @instance
     */
    SetFreeze.prototype.value = false;

    /**
     * Creates a new SetFreeze instance using the specified properties.
     * @function create
     * @memberof SetFreeze
     * @static
     * @param {ISetFreeze=} [properties] Properties to set
     * @returns {SetFreeze} SetFreeze instance
     */
    SetFreeze.create = function create(properties) {
        return new SetFreeze(properties);
    };

    /**
     * Encodes the specified SetFreeze message. Does not implicitly {@link SetFreeze.verify|verify} messages.
     * @function encode
     * @memberof SetFreeze
     * @static
     * @param {ISetFreeze} message SetFreeze message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetFreeze.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.value != null && message.hasOwnProperty("value"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
        return writer;
    };

    /**
     * Encodes the specified SetFreeze message, length delimited. Does not implicitly {@link SetFreeze.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetFreeze
     * @static
     * @param {ISetFreeze} message SetFreeze message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetFreeze.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetFreeze message from the specified reader or buffer.
     * @function decode
     * @memberof SetFreeze
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetFreeze} SetFreeze
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetFreeze.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetFreeze();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetFreeze message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetFreeze
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetFreeze} SetFreeze
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetFreeze.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetFreeze message.
     * @function verify
     * @memberof SetFreeze
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetFreeze.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value !== "boolean")
                return "value: boolean expected";
        return null;
    };

    /**
     * Creates a SetFreeze message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetFreeze
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetFreeze} SetFreeze
     */
    SetFreeze.fromObject = function fromObject(object) {
        if (object instanceof $root.SetFreeze)
            return object;
        var message = new $root.SetFreeze();
        if (object.value != null)
            message.value = Boolean(object.value);
        return message;
    };

    /**
     * Creates a plain object from a SetFreeze message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetFreeze
     * @static
     * @param {SetFreeze} message SetFreeze
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetFreeze.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.value = false;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    /**
     * Converts this SetFreeze to JSON.
     * @function toJSON
     * @memberof SetFreeze
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetFreeze.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetFreeze;
})();

$root.SetAugmentedRealityMode = (function() {

    /**
     * Properties of a SetAugmentedRealityMode.
     * @exports ISetAugmentedRealityMode
     * @interface ISetAugmentedRealityMode
     * @property {AugmentedRealityMode|null} [mode] SetAugmentedRealityMode mode
     */

    /**
     * Constructs a new SetAugmentedRealityMode.
     * @exports SetAugmentedRealityMode
     * @classdesc Represents a SetAugmentedRealityMode.
     * @implements ISetAugmentedRealityMode
     * @constructor
     * @param {ISetAugmentedRealityMode=} [properties] Properties to set
     */
    function SetAugmentedRealityMode(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SetAugmentedRealityMode mode.
     * @member {AugmentedRealityMode} mode
     * @memberof SetAugmentedRealityMode
     * @instance
     */
    SetAugmentedRealityMode.prototype.mode = 0;

    /**
     * Creates a new SetAugmentedRealityMode instance using the specified properties.
     * @function create
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {ISetAugmentedRealityMode=} [properties] Properties to set
     * @returns {SetAugmentedRealityMode} SetAugmentedRealityMode instance
     */
    SetAugmentedRealityMode.create = function create(properties) {
        return new SetAugmentedRealityMode(properties);
    };

    /**
     * Encodes the specified SetAugmentedRealityMode message. Does not implicitly {@link SetAugmentedRealityMode.verify|verify} messages.
     * @function encode
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {ISetAugmentedRealityMode} message SetAugmentedRealityMode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetAugmentedRealityMode.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mode != null && message.hasOwnProperty("mode"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
        return writer;
    };

    /**
     * Encodes the specified SetAugmentedRealityMode message, length delimited. Does not implicitly {@link SetAugmentedRealityMode.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {ISetAugmentedRealityMode} message SetAugmentedRealityMode message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetAugmentedRealityMode.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetAugmentedRealityMode message from the specified reader or buffer.
     * @function decode
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetAugmentedRealityMode} SetAugmentedRealityMode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetAugmentedRealityMode.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetAugmentedRealityMode();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.mode = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetAugmentedRealityMode message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetAugmentedRealityMode} SetAugmentedRealityMode
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetAugmentedRealityMode.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetAugmentedRealityMode message.
     * @function verify
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetAugmentedRealityMode.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mode != null && message.hasOwnProperty("mode"))
            switch (message.mode) {
            default:
                return "mode: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates a SetAugmentedRealityMode message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetAugmentedRealityMode} SetAugmentedRealityMode
     */
    SetAugmentedRealityMode.fromObject = function fromObject(object) {
        if (object instanceof $root.SetAugmentedRealityMode)
            return object;
        var message = new $root.SetAugmentedRealityMode();
        switch (object.mode) {
        case "UNKNOWN_AUGMENTED_REALITY_MODE":
        case 0:
            message.mode = 0;
            break;
        case "FULL":
        case 1:
            message.mode = 1;
            break;
        case "LOCALIZATION_ONLY":
        case 2:
            message.mode = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SetAugmentedRealityMode message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetAugmentedRealityMode
     * @static
     * @param {SetAugmentedRealityMode} message SetAugmentedRealityMode
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetAugmentedRealityMode.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.mode = options.enums === String ? "UNKNOWN_AUGMENTED_REALITY_MODE" : 0;
        if (message.mode != null && message.hasOwnProperty("mode"))
            object.mode = options.enums === String ? $root.AugmentedRealityMode[message.mode] : message.mode;
        return object;
    };

    /**
     * Converts this SetAugmentedRealityMode to JSON.
     * @function toJSON
     * @memberof SetAugmentedRealityMode
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetAugmentedRealityMode.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetAugmentedRealityMode;
})();

$root.SetImageOrientation = (function() {

    /**
     * Properties of a SetImageOrientation.
     * @exports ISetImageOrientation
     * @interface ISetImageOrientation
     * @property {SetImageOrientation.Orientation|null} [orientation] SetImageOrientation orientation
     */

    /**
     * Constructs a new SetImageOrientation.
     * @exports SetImageOrientation
     * @classdesc Represents a SetImageOrientation.
     * @implements ISetImageOrientation
     * @constructor
     * @param {ISetImageOrientation=} [properties] Properties to set
     */
    function SetImageOrientation(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SetImageOrientation orientation.
     * @member {SetImageOrientation.Orientation} orientation
     * @memberof SetImageOrientation
     * @instance
     */
    SetImageOrientation.prototype.orientation = 0;

    /**
     * Creates a new SetImageOrientation instance using the specified properties.
     * @function create
     * @memberof SetImageOrientation
     * @static
     * @param {ISetImageOrientation=} [properties] Properties to set
     * @returns {SetImageOrientation} SetImageOrientation instance
     */
    SetImageOrientation.create = function create(properties) {
        return new SetImageOrientation(properties);
    };

    /**
     * Encodes the specified SetImageOrientation message. Does not implicitly {@link SetImageOrientation.verify|verify} messages.
     * @function encode
     * @memberof SetImageOrientation
     * @static
     * @param {ISetImageOrientation} message SetImageOrientation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetImageOrientation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.orientation != null && message.hasOwnProperty("orientation"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.orientation);
        return writer;
    };

    /**
     * Encodes the specified SetImageOrientation message, length delimited. Does not implicitly {@link SetImageOrientation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetImageOrientation
     * @static
     * @param {ISetImageOrientation} message SetImageOrientation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetImageOrientation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetImageOrientation message from the specified reader or buffer.
     * @function decode
     * @memberof SetImageOrientation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetImageOrientation} SetImageOrientation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetImageOrientation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetImageOrientation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.orientation = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetImageOrientation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetImageOrientation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetImageOrientation} SetImageOrientation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetImageOrientation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetImageOrientation message.
     * @function verify
     * @memberof SetImageOrientation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetImageOrientation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.orientation != null && message.hasOwnProperty("orientation"))
            switch (message.orientation) {
            default:
                return "orientation: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates a SetImageOrientation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetImageOrientation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetImageOrientation} SetImageOrientation
     */
    SetImageOrientation.fromObject = function fromObject(object) {
        if (object instanceof $root.SetImageOrientation)
            return object;
        var message = new $root.SetImageOrientation();
        switch (object.orientation) {
        case "UNKNOWN_ORIENTATION":
        case 0:
            message.orientation = 0;
            break;
        case "PORTRAIT":
        case 1:
            message.orientation = 1;
            break;
        case "LANDSCAPE":
        case 2:
            message.orientation = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SetImageOrientation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetImageOrientation
     * @static
     * @param {SetImageOrientation} message SetImageOrientation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetImageOrientation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.orientation = options.enums === String ? "UNKNOWN_ORIENTATION" : 0;
        if (message.orientation != null && message.hasOwnProperty("orientation"))
            object.orientation = options.enums === String ? $root.SetImageOrientation.Orientation[message.orientation] : message.orientation;
        return object;
    };

    /**
     * Converts this SetImageOrientation to JSON.
     * @function toJSON
     * @memberof SetImageOrientation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetImageOrientation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Orientation enum.
     * @name SetImageOrientation.Orientation
     * @enum {string}
     * @property {number} UNKNOWN_ORIENTATION=0 UNKNOWN_ORIENTATION value
     * @property {number} PORTRAIT=1 PORTRAIT value
     * @property {number} LANDSCAPE=2 LANDSCAPE value
     */
    SetImageOrientation.Orientation = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_ORIENTATION"] = 0;
        values[valuesById[1] = "PORTRAIT"] = 1;
        values[valuesById[2] = "LANDSCAPE"] = 2;
        return values;
    })();

    return SetImageOrientation;
})();

$root.Empty = (function() {

    /**
     * Properties of an Empty.
     * @exports IEmpty
     * @interface IEmpty
     */

    /**
     * Constructs a new Empty.
     * @exports Empty
     * @classdesc Represents an Empty.
     * @implements IEmpty
     * @constructor
     * @param {IEmpty=} [properties] Properties to set
     */
    function Empty(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new Empty instance using the specified properties.
     * @function create
     * @memberof Empty
     * @static
     * @param {IEmpty=} [properties] Properties to set
     * @returns {Empty} Empty instance
     */
    Empty.create = function create(properties) {
        return new Empty(properties);
    };

    /**
     * Encodes the specified Empty message. Does not implicitly {@link Empty.verify|verify} messages.
     * @function encode
     * @memberof Empty
     * @static
     * @param {IEmpty} message Empty message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Empty.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified Empty message, length delimited. Does not implicitly {@link Empty.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Empty
     * @static
     * @param {IEmpty} message Empty message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Empty.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Empty message from the specified reader or buffer.
     * @function decode
     * @memberof Empty
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Empty} Empty
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Empty.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Empty();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Empty message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Empty
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Empty} Empty
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Empty.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Empty message.
     * @function verify
     * @memberof Empty
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Empty.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an Empty message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Empty
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Empty} Empty
     */
    Empty.fromObject = function fromObject(object) {
        if (object instanceof $root.Empty)
            return object;
        return new $root.Empty();
    };

    /**
     * Creates a plain object from an Empty message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Empty
     * @static
     * @param {Empty} message Empty
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Empty.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this Empty to JSON.
     * @function toJSON
     * @memberof Empty
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Empty.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Empty;
})();

$root.Acknowledgement = (function() {

    /**
     * Properties of an Acknowledgement.
     * @exports IAcknowledgement
     * @interface IAcknowledgement
     * @property {string|null} [requestId] Acknowledgement requestId
     * @property {boolean|null} [rejected] Acknowledgement rejected
     */

    /**
     * Constructs a new Acknowledgement.
     * @exports Acknowledgement
     * @classdesc Represents an Acknowledgement.
     * @implements IAcknowledgement
     * @constructor
     * @param {IAcknowledgement=} [properties] Properties to set
     */
    function Acknowledgement(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Acknowledgement requestId.
     * @member {string} requestId
     * @memberof Acknowledgement
     * @instance
     */
    Acknowledgement.prototype.requestId = "";

    /**
     * Acknowledgement rejected.
     * @member {boolean} rejected
     * @memberof Acknowledgement
     * @instance
     */
    Acknowledgement.prototype.rejected = false;

    /**
     * Creates a new Acknowledgement instance using the specified properties.
     * @function create
     * @memberof Acknowledgement
     * @static
     * @param {IAcknowledgement=} [properties] Properties to set
     * @returns {Acknowledgement} Acknowledgement instance
     */
    Acknowledgement.create = function create(properties) {
        return new Acknowledgement(properties);
    };

    /**
     * Encodes the specified Acknowledgement message. Does not implicitly {@link Acknowledgement.verify|verify} messages.
     * @function encode
     * @memberof Acknowledgement
     * @static
     * @param {IAcknowledgement} message Acknowledgement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Acknowledgement.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
        if (message.rejected != null && message.hasOwnProperty("rejected"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.rejected);
        return writer;
    };

    /**
     * Encodes the specified Acknowledgement message, length delimited. Does not implicitly {@link Acknowledgement.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Acknowledgement
     * @static
     * @param {IAcknowledgement} message Acknowledgement message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Acknowledgement.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Acknowledgement message from the specified reader or buffer.
     * @function decode
     * @memberof Acknowledgement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Acknowledgement} Acknowledgement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Acknowledgement.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Acknowledgement();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.requestId = reader.string();
                break;
            case 2:
                message.rejected = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Acknowledgement message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Acknowledgement
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Acknowledgement} Acknowledgement
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Acknowledgement.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Acknowledgement message.
     * @function verify
     * @memberof Acknowledgement
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Acknowledgement.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isString(message.requestId))
                return "requestId: string expected";
        if (message.rejected != null && message.hasOwnProperty("rejected"))
            if (typeof message.rejected !== "boolean")
                return "rejected: boolean expected";
        return null;
    };

    /**
     * Creates an Acknowledgement message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Acknowledgement
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Acknowledgement} Acknowledgement
     */
    Acknowledgement.fromObject = function fromObject(object) {
        if (object instanceof $root.Acknowledgement)
            return object;
        var message = new $root.Acknowledgement();
        if (object.requestId != null)
            message.requestId = String(object.requestId);
        if (object.rejected != null)
            message.rejected = Boolean(object.rejected);
        return message;
    };

    /**
     * Creates a plain object from an Acknowledgement message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Acknowledgement
     * @static
     * @param {Acknowledgement} message Acknowledgement
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Acknowledgement.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.requestId = "";
            object.rejected = false;
        }
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.rejected != null && message.hasOwnProperty("rejected"))
            object.rejected = message.rejected;
        return object;
    };

    /**
     * Converts this Acknowledgement to JSON.
     * @function toJSON
     * @memberof Acknowledgement
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Acknowledgement.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Acknowledgement;
})();

/**
 * TemperatureState enum.
 * @exports TemperatureState
 * @enum {string}
 * @property {number} UNKNOWN_TEMP=0 UNKNOWN_TEMP value
 * @property {number} NORMAL=1 NORMAL value
 * @property {number} HOT=2 HOT value
 * @property {number} HOT_SHUTDOWN=3 HOT_SHUTDOWN value
 * @property {number} COLD_SHUTDOWN=4 COLD_SHUTDOWN value
 */
$root.TemperatureState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_TEMP"] = 0;
    values[valuesById[1] = "NORMAL"] = 1;
    values[valuesById[2] = "HOT"] = 2;
    values[valuesById[3] = "HOT_SHUTDOWN"] = 3;
    values[valuesById[4] = "COLD_SHUTDOWN"] = 4;
    return values;
})();

/**
 * ProbeState enum.
 * @exports ProbeState
 * @enum {string}
 * @property {number} UNKNOWN_PROBE=0 UNKNOWN_PROBE value
 * @property {number} CHARGING=1 CHARGING value
 * @property {number} CONNECTED=2 CONNECTED value
 * @property {number} DISCONNECTED=3 DISCONNECTED value
 * @property {number} HARDWARE_INCOMPATIBLE=4 HARDWARE_INCOMPATIBLE value
 * @property {number} FIRMWARE_INCOMPATIBLE=5 FIRMWARE_INCOMPATIBLE value
 * @property {number} NOT_READY=6 NOT_READY value
 * @property {number} READY=7 READY value
 */
$root.ProbeState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_PROBE"] = 0;
    values[valuesById[1] = "CHARGING"] = 1;
    values[valuesById[2] = "CONNECTED"] = 2;
    values[valuesById[3] = "DISCONNECTED"] = 3;
    values[valuesById[4] = "HARDWARE_INCOMPATIBLE"] = 4;
    values[valuesById[5] = "FIRMWARE_INCOMPATIBLE"] = 5;
    values[valuesById[6] = "NOT_READY"] = 6;
    values[valuesById[7] = "READY"] = 7;
    return values;
})();

/**
 * BatteryState enum.
 * @exports BatteryState
 * @enum {string}
 * @property {number} UNKNOWN_BATTERY=0 UNKNOWN_BATTERY value
 * @property {number} NORMAL_BATTERY=1 NORMAL_BATTERY value
 * @property {number} WARNING=2 WARNING value
 * @property {number} CRITICAL=3 CRITICAL value
 */
$root.BatteryState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_BATTERY"] = 0;
    values[valuesById[1] = "NORMAL_BATTERY"] = 1;
    values[valuesById[2] = "WARNING"] = 2;
    values[valuesById[3] = "CRITICAL"] = 3;
    return values;
})();

/**
 * ImagingMode enum.
 * @exports ImagingMode
 * @enum {string}
 * @property {number} UNKNOWN_MODE=0 UNKNOWN_MODE value
 * @property {number} B_MODE=1 B_MODE value
 * @property {number} COLOR_DOPPLER=2 COLOR_DOPPLER value
 * @property {number} POWER_DOPPLER=3 POWER_DOPPLER value
 */
$root.ImagingMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_MODE"] = 0;
    values[valuesById[1] = "B_MODE"] = 1;
    values[valuesById[2] = "COLOR_DOPPLER"] = 2;
    values[valuesById[3] = "POWER_DOPPLER"] = 3;
    return values;
})();

/**
 * AugmentedRealityMode enum.
 * @exports AugmentedRealityMode
 * @enum {string}
 * @property {number} UNKNOWN_AUGMENTED_REALITY_MODE=0 UNKNOWN_AUGMENTED_REALITY_MODE value
 * @property {number} FULL=1 FULL value
 * @property {number} LOCALIZATION_ONLY=2 LOCALIZATION_ONLY value
 */
$root.AugmentedRealityMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_AUGMENTED_REALITY_MODE"] = 0;
    values[valuesById[1] = "FULL"] = 1;
    values[valuesById[2] = "LOCALIZATION_ONLY"] = 2;
    return values;
})();

/**
 * CameraMode enum.
 * @exports CameraMode
 * @enum {string}
 * @property {number} UNKNOWN_CAMERA_MODE=0 UNKNOWN_CAMERA_MODE value
 * @property {number} FRONT=1 FRONT value
 * @property {number} BACK=2 BACK value
 */
$root.CameraMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_CAMERA_MODE"] = 0;
    values[valuesById[1] = "FRONT"] = 1;
    values[valuesById[2] = "BACK"] = 2;
    return values;
})();

$root.Instruction = (function() {

    /**
     * Properties of an Instruction.
     * @exports IInstruction
     * @interface IInstruction
     * @property {Instruction.ITranslate|null} [translate] Instruction translate
     * @property {IEmpty|null} [rotateClockwise] Instruction rotateClockwise
     * @property {IEmpty|null} [rotateCounterClockwise] Instruction rotateCounterClockwise
     * @property {IEmpty|null} [tiltHeadUp] Instruction tiltHeadUp
     * @property {IEmpty|null} [tiltHeadDown] Instruction tiltHeadDown
     * @property {IEmpty|null} [holdPosition] Instruction holdPosition
     * @property {Instruction.ITilt|null} [tilt] Instruction tilt
     * @property {number|null} [durationSeconds] Instruction durationSeconds
     */

    /**
     * Constructs a new Instruction.
     * @exports Instruction
     * @classdesc Represents an Instruction.
     * @implements IInstruction
     * @constructor
     * @param {IInstruction=} [properties] Properties to set
     */
    function Instruction(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Instruction translate.
     * @member {Instruction.ITranslate|null|undefined} translate
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.translate = null;

    /**
     * Instruction rotateClockwise.
     * @member {IEmpty|null|undefined} rotateClockwise
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.rotateClockwise = null;

    /**
     * Instruction rotateCounterClockwise.
     * @member {IEmpty|null|undefined} rotateCounterClockwise
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.rotateCounterClockwise = null;

    /**
     * Instruction tiltHeadUp.
     * @member {IEmpty|null|undefined} tiltHeadUp
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.tiltHeadUp = null;

    /**
     * Instruction tiltHeadDown.
     * @member {IEmpty|null|undefined} tiltHeadDown
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.tiltHeadDown = null;

    /**
     * Instruction holdPosition.
     * @member {IEmpty|null|undefined} holdPosition
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.holdPosition = null;

    /**
     * Instruction tilt.
     * @member {Instruction.ITilt|null|undefined} tilt
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.tilt = null;

    /**
     * Instruction durationSeconds.
     * @member {number} durationSeconds
     * @memberof Instruction
     * @instance
     */
    Instruction.prototype.durationSeconds = 0;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * Instruction type.
     * @member {"translate"|"rotateClockwise"|"rotateCounterClockwise"|"tiltHeadUp"|"tiltHeadDown"|"holdPosition"|"tilt"|undefined} type
     * @memberof Instruction
     * @instance
     */
    Object.defineProperty(Instruction.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["translate", "rotateClockwise", "rotateCounterClockwise", "tiltHeadUp", "tiltHeadDown", "holdPosition", "tilt"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Instruction instance using the specified properties.
     * @function create
     * @memberof Instruction
     * @static
     * @param {IInstruction=} [properties] Properties to set
     * @returns {Instruction} Instruction instance
     */
    Instruction.create = function create(properties) {
        return new Instruction(properties);
    };

    /**
     * Encodes the specified Instruction message. Does not implicitly {@link Instruction.verify|verify} messages.
     * @function encode
     * @memberof Instruction
     * @static
     * @param {IInstruction} message Instruction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Instruction.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.translate != null && message.hasOwnProperty("translate"))
            $root.Instruction.Translate.encode(message.translate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.rotateClockwise != null && message.hasOwnProperty("rotateClockwise"))
            $root.Empty.encode(message.rotateClockwise, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.rotateCounterClockwise != null && message.hasOwnProperty("rotateCounterClockwise"))
            $root.Empty.encode(message.rotateCounterClockwise, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.tiltHeadUp != null && message.hasOwnProperty("tiltHeadUp"))
            $root.Empty.encode(message.tiltHeadUp, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.tiltHeadDown != null && message.hasOwnProperty("tiltHeadDown"))
            $root.Empty.encode(message.tiltHeadDown, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.holdPosition != null && message.hasOwnProperty("holdPosition"))
            $root.Empty.encode(message.holdPosition, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
            writer.uint32(/* id 7, wireType 5 =*/61).float(message.durationSeconds);
        if (message.tilt != null && message.hasOwnProperty("tilt"))
            $root.Instruction.Tilt.encode(message.tilt, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Instruction message, length delimited. Does not implicitly {@link Instruction.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Instruction
     * @static
     * @param {IInstruction} message Instruction message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Instruction.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Instruction message from the specified reader or buffer.
     * @function decode
     * @memberof Instruction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Instruction} Instruction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Instruction.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Instruction();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.translate = $root.Instruction.Translate.decode(reader, reader.uint32());
                break;
            case 2:
                message.rotateClockwise = $root.Empty.decode(reader, reader.uint32());
                break;
            case 3:
                message.rotateCounterClockwise = $root.Empty.decode(reader, reader.uint32());
                break;
            case 4:
                message.tiltHeadUp = $root.Empty.decode(reader, reader.uint32());
                break;
            case 5:
                message.tiltHeadDown = $root.Empty.decode(reader, reader.uint32());
                break;
            case 6:
                message.holdPosition = $root.Empty.decode(reader, reader.uint32());
                break;
            case 8:
                message.tilt = $root.Instruction.Tilt.decode(reader, reader.uint32());
                break;
            case 7:
                message.durationSeconds = reader.float();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Instruction message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Instruction
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Instruction} Instruction
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Instruction.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Instruction message.
     * @function verify
     * @memberof Instruction
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Instruction.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.translate != null && message.hasOwnProperty("translate")) {
            properties.type = 1;
            {
                var error = $root.Instruction.Translate.verify(message.translate);
                if (error)
                    return "translate." + error;
            }
        }
        if (message.rotateClockwise != null && message.hasOwnProperty("rotateClockwise")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Empty.verify(message.rotateClockwise);
                if (error)
                    return "rotateClockwise." + error;
            }
        }
        if (message.rotateCounterClockwise != null && message.hasOwnProperty("rotateCounterClockwise")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Empty.verify(message.rotateCounterClockwise);
                if (error)
                    return "rotateCounterClockwise." + error;
            }
        }
        if (message.tiltHeadUp != null && message.hasOwnProperty("tiltHeadUp")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Empty.verify(message.tiltHeadUp);
                if (error)
                    return "tiltHeadUp." + error;
            }
        }
        if (message.tiltHeadDown != null && message.hasOwnProperty("tiltHeadDown")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Empty.verify(message.tiltHeadDown);
                if (error)
                    return "tiltHeadDown." + error;
            }
        }
        if (message.holdPosition != null && message.hasOwnProperty("holdPosition")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Empty.verify(message.holdPosition);
                if (error)
                    return "holdPosition." + error;
            }
        }
        if (message.tilt != null && message.hasOwnProperty("tilt")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                var error = $root.Instruction.Tilt.verify(message.tilt);
                if (error)
                    return "tilt." + error;
            }
        }
        if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
            if (typeof message.durationSeconds !== "number")
                return "durationSeconds: number expected";
        return null;
    };

    /**
     * Creates an Instruction message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Instruction
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Instruction} Instruction
     */
    Instruction.fromObject = function fromObject(object) {
        if (object instanceof $root.Instruction)
            return object;
        var message = new $root.Instruction();
        if (object.translate != null) {
            if (typeof object.translate !== "object")
                throw TypeError(".Instruction.translate: object expected");
            message.translate = $root.Instruction.Translate.fromObject(object.translate);
        }
        if (object.rotateClockwise != null) {
            if (typeof object.rotateClockwise !== "object")
                throw TypeError(".Instruction.rotateClockwise: object expected");
            message.rotateClockwise = $root.Empty.fromObject(object.rotateClockwise);
        }
        if (object.rotateCounterClockwise != null) {
            if (typeof object.rotateCounterClockwise !== "object")
                throw TypeError(".Instruction.rotateCounterClockwise: object expected");
            message.rotateCounterClockwise = $root.Empty.fromObject(object.rotateCounterClockwise);
        }
        if (object.tiltHeadUp != null) {
            if (typeof object.tiltHeadUp !== "object")
                throw TypeError(".Instruction.tiltHeadUp: object expected");
            message.tiltHeadUp = $root.Empty.fromObject(object.tiltHeadUp);
        }
        if (object.tiltHeadDown != null) {
            if (typeof object.tiltHeadDown !== "object")
                throw TypeError(".Instruction.tiltHeadDown: object expected");
            message.tiltHeadDown = $root.Empty.fromObject(object.tiltHeadDown);
        }
        if (object.holdPosition != null) {
            if (typeof object.holdPosition !== "object")
                throw TypeError(".Instruction.holdPosition: object expected");
            message.holdPosition = $root.Empty.fromObject(object.holdPosition);
        }
        if (object.tilt != null) {
            if (typeof object.tilt !== "object")
                throw TypeError(".Instruction.tilt: object expected");
            message.tilt = $root.Instruction.Tilt.fromObject(object.tilt);
        }
        if (object.durationSeconds != null)
            message.durationSeconds = Number(object.durationSeconds);
        return message;
    };

    /**
     * Creates a plain object from an Instruction message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Instruction
     * @static
     * @param {Instruction} message Instruction
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Instruction.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.durationSeconds = 0;
        if (message.translate != null && message.hasOwnProperty("translate")) {
            object.translate = $root.Instruction.Translate.toObject(message.translate, options);
            if (options.oneofs)
                object.type = "translate";
        }
        if (message.rotateClockwise != null && message.hasOwnProperty("rotateClockwise")) {
            object.rotateClockwise = $root.Empty.toObject(message.rotateClockwise, options);
            if (options.oneofs)
                object.type = "rotateClockwise";
        }
        if (message.rotateCounterClockwise != null && message.hasOwnProperty("rotateCounterClockwise")) {
            object.rotateCounterClockwise = $root.Empty.toObject(message.rotateCounterClockwise, options);
            if (options.oneofs)
                object.type = "rotateCounterClockwise";
        }
        if (message.tiltHeadUp != null && message.hasOwnProperty("tiltHeadUp")) {
            object.tiltHeadUp = $root.Empty.toObject(message.tiltHeadUp, options);
            if (options.oneofs)
                object.type = "tiltHeadUp";
        }
        if (message.tiltHeadDown != null && message.hasOwnProperty("tiltHeadDown")) {
            object.tiltHeadDown = $root.Empty.toObject(message.tiltHeadDown, options);
            if (options.oneofs)
                object.type = "tiltHeadDown";
        }
        if (message.holdPosition != null && message.hasOwnProperty("holdPosition")) {
            object.holdPosition = $root.Empty.toObject(message.holdPosition, options);
            if (options.oneofs)
                object.type = "holdPosition";
        }
        if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
            object.durationSeconds = options.json && !isFinite(message.durationSeconds) ? String(message.durationSeconds) : message.durationSeconds;
        if (message.tilt != null && message.hasOwnProperty("tilt")) {
            object.tilt = $root.Instruction.Tilt.toObject(message.tilt, options);
            if (options.oneofs)
                object.type = "tilt";
        }
        return object;
    };

    /**
     * Converts this Instruction to JSON.
     * @function toJSON
     * @memberof Instruction
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Instruction.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    Instruction.Translate = (function() {

        /**
         * Properties of a Translate.
         * @memberof Instruction
         * @interface ITranslate
         * @property {number|null} [degrees] Translate degrees
         * @property {number|null} [magnitude] Translate magnitude
         * @property {number|null} [direction] Translate direction
         */

        /**
         * Constructs a new Translate.
         * @memberof Instruction
         * @classdesc Represents a Translate.
         * @implements ITranslate
         * @constructor
         * @param {Instruction.ITranslate=} [properties] Properties to set
         */
        function Translate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Translate degrees.
         * @member {number} degrees
         * @memberof Instruction.Translate
         * @instance
         */
        Translate.prototype.degrees = 0;

        /**
         * Translate magnitude.
         * @member {number} magnitude
         * @memberof Instruction.Translate
         * @instance
         */
        Translate.prototype.magnitude = 0;

        /**
         * Translate direction.
         * @member {number} direction
         * @memberof Instruction.Translate
         * @instance
         */
        Translate.prototype.direction = 0;

        /**
         * Creates a new Translate instance using the specified properties.
         * @function create
         * @memberof Instruction.Translate
         * @static
         * @param {Instruction.ITranslate=} [properties] Properties to set
         * @returns {Instruction.Translate} Translate instance
         */
        Translate.create = function create(properties) {
            return new Translate(properties);
        };

        /**
         * Encodes the specified Translate message. Does not implicitly {@link Instruction.Translate.verify|verify} messages.
         * @function encode
         * @memberof Instruction.Translate
         * @static
         * @param {Instruction.ITranslate} message Translate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Translate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.degrees != null && message.hasOwnProperty("degrees"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.degrees);
            if (message.magnitude != null && message.hasOwnProperty("magnitude"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.magnitude);
            if (message.direction != null && message.hasOwnProperty("direction"))
                writer.uint32(/* id 3, wireType 5 =*/29).float(message.direction);
            return writer;
        };

        /**
         * Encodes the specified Translate message, length delimited. Does not implicitly {@link Instruction.Translate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Instruction.Translate
         * @static
         * @param {Instruction.ITranslate} message Translate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Translate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Translate message from the specified reader or buffer.
         * @function decode
         * @memberof Instruction.Translate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Instruction.Translate} Translate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Translate.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Instruction.Translate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.degrees = reader.float();
                    break;
                case 2:
                    message.magnitude = reader.float();
                    break;
                case 3:
                    message.direction = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Translate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Instruction.Translate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Instruction.Translate} Translate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Translate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Translate message.
         * @function verify
         * @memberof Instruction.Translate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Translate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.degrees != null && message.hasOwnProperty("degrees"))
                if (typeof message.degrees !== "number")
                    return "degrees: number expected";
            if (message.magnitude != null && message.hasOwnProperty("magnitude"))
                if (typeof message.magnitude !== "number")
                    return "magnitude: number expected";
            if (message.direction != null && message.hasOwnProperty("direction"))
                if (typeof message.direction !== "number")
                    return "direction: number expected";
            return null;
        };

        /**
         * Creates a Translate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Instruction.Translate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Instruction.Translate} Translate
         */
        Translate.fromObject = function fromObject(object) {
            if (object instanceof $root.Instruction.Translate)
                return object;
            var message = new $root.Instruction.Translate();
            if (object.degrees != null)
                message.degrees = Number(object.degrees);
            if (object.magnitude != null)
                message.magnitude = Number(object.magnitude);
            if (object.direction != null)
                message.direction = Number(object.direction);
            return message;
        };

        /**
         * Creates a plain object from a Translate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Instruction.Translate
         * @static
         * @param {Instruction.Translate} message Translate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Translate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.degrees = 0;
                object.magnitude = 0;
                object.direction = 0;
            }
            if (message.degrees != null && message.hasOwnProperty("degrees"))
                object.degrees = options.json && !isFinite(message.degrees) ? String(message.degrees) : message.degrees;
            if (message.magnitude != null && message.hasOwnProperty("magnitude"))
                object.magnitude = options.json && !isFinite(message.magnitude) ? String(message.magnitude) : message.magnitude;
            if (message.direction != null && message.hasOwnProperty("direction"))
                object.direction = options.json && !isFinite(message.direction) ? String(message.direction) : message.direction;
            return object;
        };

        /**
         * Converts this Translate to JSON.
         * @function toJSON
         * @memberof Instruction.Translate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Translate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Translate;
    })();

    Instruction.Tilt = (function() {

        /**
         * Properties of a Tilt.
         * @memberof Instruction
         * @interface ITilt
         * @property {number|null} [direction] Tilt direction
         */

        /**
         * Constructs a new Tilt.
         * @memberof Instruction
         * @classdesc Represents a Tilt.
         * @implements ITilt
         * @constructor
         * @param {Instruction.ITilt=} [properties] Properties to set
         */
        function Tilt(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Tilt direction.
         * @member {number} direction
         * @memberof Instruction.Tilt
         * @instance
         */
        Tilt.prototype.direction = 0;

        /**
         * Creates a new Tilt instance using the specified properties.
         * @function create
         * @memberof Instruction.Tilt
         * @static
         * @param {Instruction.ITilt=} [properties] Properties to set
         * @returns {Instruction.Tilt} Tilt instance
         */
        Tilt.create = function create(properties) {
            return new Tilt(properties);
        };

        /**
         * Encodes the specified Tilt message. Does not implicitly {@link Instruction.Tilt.verify|verify} messages.
         * @function encode
         * @memberof Instruction.Tilt
         * @static
         * @param {Instruction.ITilt} message Tilt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Tilt.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.direction != null && message.hasOwnProperty("direction"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.direction);
            return writer;
        };

        /**
         * Encodes the specified Tilt message, length delimited. Does not implicitly {@link Instruction.Tilt.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Instruction.Tilt
         * @static
         * @param {Instruction.ITilt} message Tilt message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Tilt.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Tilt message from the specified reader or buffer.
         * @function decode
         * @memberof Instruction.Tilt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Instruction.Tilt} Tilt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Tilt.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Instruction.Tilt();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.direction = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Tilt message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Instruction.Tilt
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Instruction.Tilt} Tilt
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Tilt.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Tilt message.
         * @function verify
         * @memberof Instruction.Tilt
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Tilt.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.direction != null && message.hasOwnProperty("direction"))
                if (typeof message.direction !== "number")
                    return "direction: number expected";
            return null;
        };

        /**
         * Creates a Tilt message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Instruction.Tilt
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Instruction.Tilt} Tilt
         */
        Tilt.fromObject = function fromObject(object) {
            if (object instanceof $root.Instruction.Tilt)
                return object;
            var message = new $root.Instruction.Tilt();
            if (object.direction != null)
                message.direction = Number(object.direction);
            return message;
        };

        /**
         * Creates a plain object from a Tilt message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Instruction.Tilt
         * @static
         * @param {Instruction.Tilt} message Tilt
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Tilt.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.direction = 0;
            if (message.direction != null && message.hasOwnProperty("direction"))
                object.direction = options.json && !isFinite(message.direction) ? String(message.direction) : message.direction;
            return object;
        };

        /**
         * Converts this Tilt to JSON.
         * @function toJSON
         * @memberof Instruction.Tilt
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Tilt.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Tilt;
    })();

    return Instruction;
})();

$root.HeliosEvent = (function() {

    /**
     * Properties of a HeliosEvent.
     * @exports IHeliosEvent
     * @interface IHeliosEvent
     * @property {IAcknowledgement|null} [ack] HeliosEvent ack
     * @property {HeliosEvent.IPose|null} [pose] HeliosEvent pose
     * @property {HeliosEvent.IFreezeChanged|null} [freezeChanged] HeliosEvent freezeChanged
     * @property {HeliosEvent.IModeChanged|null} [modeChanged] HeliosEvent modeChanged
     * @property {HeliosEvent.IDepthChanged|null} [depthChanged] HeliosEvent depthChanged
     * @property {HeliosEvent.IGainChanged|null} [gainChanged] HeliosEvent gainChanged
     * @property {HeliosEvent.IPresetChanged|null} [presetChanged] HeliosEvent presetChanged
     * @property {HeliosEvent.ICameraModeChanged|null} [cameraModeChanged] HeliosEvent cameraModeChanged
     * @property {HeliosEvent.IProbeStateChanged|null} [probeStateChanged] HeliosEvent probeStateChanged
     * @property {HeliosEvent.ITemperatureStateChanged|null} [temperatureStateChanged] HeliosEvent temperatureStateChanged
     * @property {HeliosEvent.ICurrentSettings|null} [currentSettings] HeliosEvent currentSettings
     * @property {HeliosEvent.IDisconnected|null} [disconnected] HeliosEvent disconnected
     * @property {IEmpty|null} [cineCaptureStarted] HeliosEvent cineCaptureStarted
     * @property {IEmpty|null} [cineCaptureStopped] HeliosEvent cineCaptureStopped
     * @property {IEmpty|null} [cineCaptureCancelled] HeliosEvent cineCaptureCancelled
     * @property {IEmpty|null} [stillCaptured] HeliosEvent stillCaptured
     * @property {HeliosEvent.IVideoDimension|null} [probeDimension] HeliosEvent probeDimension
     * @property {HeliosEvent.IVideoDimension|null} [cameraDimension] HeliosEvent cameraDimension
     * @property {HeliosEvent.IBatteryStateChanged|null} [batteryStateChanged] HeliosEvent batteryStateChanged
     */

    /**
     * Constructs a new HeliosEvent.
     * @exports HeliosEvent
     * @classdesc Represents a HeliosEvent.
     * @implements IHeliosEvent
     * @constructor
     * @param {IHeliosEvent=} [properties] Properties to set
     */
    function HeliosEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * HeliosEvent ack.
     * @member {IAcknowledgement|null|undefined} ack
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.ack = null;

    /**
     * HeliosEvent pose.
     * @member {HeliosEvent.IPose|null|undefined} pose
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.pose = null;

    /**
     * HeliosEvent freezeChanged.
     * @member {HeliosEvent.IFreezeChanged|null|undefined} freezeChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.freezeChanged = null;

    /**
     * HeliosEvent modeChanged.
     * @member {HeliosEvent.IModeChanged|null|undefined} modeChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.modeChanged = null;

    /**
     * HeliosEvent depthChanged.
     * @member {HeliosEvent.IDepthChanged|null|undefined} depthChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.depthChanged = null;

    /**
     * HeliosEvent gainChanged.
     * @member {HeliosEvent.IGainChanged|null|undefined} gainChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.gainChanged = null;

    /**
     * HeliosEvent presetChanged.
     * @member {HeliosEvent.IPresetChanged|null|undefined} presetChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.presetChanged = null;

    /**
     * HeliosEvent cameraModeChanged.
     * @member {HeliosEvent.ICameraModeChanged|null|undefined} cameraModeChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.cameraModeChanged = null;

    /**
     * HeliosEvent probeStateChanged.
     * @member {HeliosEvent.IProbeStateChanged|null|undefined} probeStateChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.probeStateChanged = null;

    /**
     * HeliosEvent temperatureStateChanged.
     * @member {HeliosEvent.ITemperatureStateChanged|null|undefined} temperatureStateChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.temperatureStateChanged = null;

    /**
     * HeliosEvent currentSettings.
     * @member {HeliosEvent.ICurrentSettings|null|undefined} currentSettings
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.currentSettings = null;

    /**
     * HeliosEvent disconnected.
     * @member {HeliosEvent.IDisconnected|null|undefined} disconnected
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.disconnected = null;

    /**
     * HeliosEvent cineCaptureStarted.
     * @member {IEmpty|null|undefined} cineCaptureStarted
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.cineCaptureStarted = null;

    /**
     * HeliosEvent cineCaptureStopped.
     * @member {IEmpty|null|undefined} cineCaptureStopped
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.cineCaptureStopped = null;

    /**
     * HeliosEvent cineCaptureCancelled.
     * @member {IEmpty|null|undefined} cineCaptureCancelled
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.cineCaptureCancelled = null;

    /**
     * HeliosEvent stillCaptured.
     * @member {IEmpty|null|undefined} stillCaptured
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.stillCaptured = null;

    /**
     * HeliosEvent probeDimension.
     * @member {HeliosEvent.IVideoDimension|null|undefined} probeDimension
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.probeDimension = null;

    /**
     * HeliosEvent cameraDimension.
     * @member {HeliosEvent.IVideoDimension|null|undefined} cameraDimension
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.cameraDimension = null;

    /**
     * HeliosEvent batteryStateChanged.
     * @member {HeliosEvent.IBatteryStateChanged|null|undefined} batteryStateChanged
     * @memberof HeliosEvent
     * @instance
     */
    HeliosEvent.prototype.batteryStateChanged = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * HeliosEvent event.
     * @member {"ack"|"pose"|"freezeChanged"|"modeChanged"|"depthChanged"|"gainChanged"|"presetChanged"|"cameraModeChanged"|"probeStateChanged"|"temperatureStateChanged"|"currentSettings"|"disconnected"|"cineCaptureStarted"|"cineCaptureStopped"|"cineCaptureCancelled"|"stillCaptured"|"probeDimension"|"cameraDimension"|"batteryStateChanged"|undefined} event
     * @memberof HeliosEvent
     * @instance
     */
    Object.defineProperty(HeliosEvent.prototype, "event", {
        get: $util.oneOfGetter($oneOfFields = ["ack", "pose", "freezeChanged", "modeChanged", "depthChanged", "gainChanged", "presetChanged", "cameraModeChanged", "probeStateChanged", "temperatureStateChanged", "currentSettings", "disconnected", "cineCaptureStarted", "cineCaptureStopped", "cineCaptureCancelled", "stillCaptured", "probeDimension", "cameraDimension", "batteryStateChanged"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new HeliosEvent instance using the specified properties.
     * @function create
     * @memberof HeliosEvent
     * @static
     * @param {IHeliosEvent=} [properties] Properties to set
     * @returns {HeliosEvent} HeliosEvent instance
     */
    HeliosEvent.create = function create(properties) {
        return new HeliosEvent(properties);
    };

    /**
     * Encodes the specified HeliosEvent message. Does not implicitly {@link HeliosEvent.verify|verify} messages.
     * @function encode
     * @memberof HeliosEvent
     * @static
     * @param {IHeliosEvent} message HeliosEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HeliosEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ack != null && message.hasOwnProperty("ack"))
            $root.Acknowledgement.encode(message.ack, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.pose != null && message.hasOwnProperty("pose"))
            $root.HeliosEvent.Pose.encode(message.pose, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.freezeChanged != null && message.hasOwnProperty("freezeChanged"))
            $root.HeliosEvent.FreezeChanged.encode(message.freezeChanged, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.modeChanged != null && message.hasOwnProperty("modeChanged"))
            $root.HeliosEvent.ModeChanged.encode(message.modeChanged, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.depthChanged != null && message.hasOwnProperty("depthChanged"))
            $root.HeliosEvent.DepthChanged.encode(message.depthChanged, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.gainChanged != null && message.hasOwnProperty("gainChanged"))
            $root.HeliosEvent.GainChanged.encode(message.gainChanged, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.presetChanged != null && message.hasOwnProperty("presetChanged"))
            $root.HeliosEvent.PresetChanged.encode(message.presetChanged, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.cameraModeChanged != null && message.hasOwnProperty("cameraModeChanged"))
            $root.HeliosEvent.CameraModeChanged.encode(message.cameraModeChanged, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.probeStateChanged != null && message.hasOwnProperty("probeStateChanged"))
            $root.HeliosEvent.ProbeStateChanged.encode(message.probeStateChanged, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.temperatureStateChanged != null && message.hasOwnProperty("temperatureStateChanged"))
            $root.HeliosEvent.TemperatureStateChanged.encode(message.temperatureStateChanged, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.currentSettings != null && message.hasOwnProperty("currentSettings"))
            $root.HeliosEvent.CurrentSettings.encode(message.currentSettings, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.disconnected != null && message.hasOwnProperty("disconnected"))
            $root.HeliosEvent.Disconnected.encode(message.disconnected, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.cineCaptureStarted != null && message.hasOwnProperty("cineCaptureStarted"))
            $root.Empty.encode(message.cineCaptureStarted, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.cineCaptureStopped != null && message.hasOwnProperty("cineCaptureStopped"))
            $root.Empty.encode(message.cineCaptureStopped, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.cineCaptureCancelled != null && message.hasOwnProperty("cineCaptureCancelled"))
            $root.Empty.encode(message.cineCaptureCancelled, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
        if (message.stillCaptured != null && message.hasOwnProperty("stillCaptured"))
            $root.Empty.encode(message.stillCaptured, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
        if (message.probeDimension != null && message.hasOwnProperty("probeDimension"))
            $root.HeliosEvent.VideoDimension.encode(message.probeDimension, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
        if (message.cameraDimension != null && message.hasOwnProperty("cameraDimension"))
            $root.HeliosEvent.VideoDimension.encode(message.cameraDimension, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
        if (message.batteryStateChanged != null && message.hasOwnProperty("batteryStateChanged"))
            $root.HeliosEvent.BatteryStateChanged.encode(message.batteryStateChanged, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified HeliosEvent message, length delimited. Does not implicitly {@link HeliosEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HeliosEvent
     * @static
     * @param {IHeliosEvent} message HeliosEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HeliosEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HeliosEvent message from the specified reader or buffer.
     * @function decode
     * @memberof HeliosEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HeliosEvent} HeliosEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HeliosEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ack = $root.Acknowledgement.decode(reader, reader.uint32());
                break;
            case 2:
                message.pose = $root.HeliosEvent.Pose.decode(reader, reader.uint32());
                break;
            case 3:
                message.freezeChanged = $root.HeliosEvent.FreezeChanged.decode(reader, reader.uint32());
                break;
            case 4:
                message.modeChanged = $root.HeliosEvent.ModeChanged.decode(reader, reader.uint32());
                break;
            case 5:
                message.depthChanged = $root.HeliosEvent.DepthChanged.decode(reader, reader.uint32());
                break;
            case 6:
                message.gainChanged = $root.HeliosEvent.GainChanged.decode(reader, reader.uint32());
                break;
            case 7:
                message.presetChanged = $root.HeliosEvent.PresetChanged.decode(reader, reader.uint32());
                break;
            case 8:
                message.cameraModeChanged = $root.HeliosEvent.CameraModeChanged.decode(reader, reader.uint32());
                break;
            case 9:
                message.probeStateChanged = $root.HeliosEvent.ProbeStateChanged.decode(reader, reader.uint32());
                break;
            case 10:
                message.temperatureStateChanged = $root.HeliosEvent.TemperatureStateChanged.decode(reader, reader.uint32());
                break;
            case 11:
                message.currentSettings = $root.HeliosEvent.CurrentSettings.decode(reader, reader.uint32());
                break;
            case 12:
                message.disconnected = $root.HeliosEvent.Disconnected.decode(reader, reader.uint32());
                break;
            case 13:
                message.cineCaptureStarted = $root.Empty.decode(reader, reader.uint32());
                break;
            case 14:
                message.cineCaptureStopped = $root.Empty.decode(reader, reader.uint32());
                break;
            case 15:
                message.cineCaptureCancelled = $root.Empty.decode(reader, reader.uint32());
                break;
            case 16:
                message.stillCaptured = $root.Empty.decode(reader, reader.uint32());
                break;
            case 18:
                message.probeDimension = $root.HeliosEvent.VideoDimension.decode(reader, reader.uint32());
                break;
            case 19:
                message.cameraDimension = $root.HeliosEvent.VideoDimension.decode(reader, reader.uint32());
                break;
            case 20:
                message.batteryStateChanged = $root.HeliosEvent.BatteryStateChanged.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HeliosEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HeliosEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HeliosEvent} HeliosEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HeliosEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HeliosEvent message.
     * @function verify
     * @memberof HeliosEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HeliosEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.ack != null && message.hasOwnProperty("ack")) {
            properties.event = 1;
            {
                var error = $root.Acknowledgement.verify(message.ack);
                if (error)
                    return "ack." + error;
            }
        }
        if (message.pose != null && message.hasOwnProperty("pose")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.Pose.verify(message.pose);
                if (error)
                    return "pose." + error;
            }
        }
        if (message.freezeChanged != null && message.hasOwnProperty("freezeChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.FreezeChanged.verify(message.freezeChanged);
                if (error)
                    return "freezeChanged." + error;
            }
        }
        if (message.modeChanged != null && message.hasOwnProperty("modeChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.ModeChanged.verify(message.modeChanged);
                if (error)
                    return "modeChanged." + error;
            }
        }
        if (message.depthChanged != null && message.hasOwnProperty("depthChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.DepthChanged.verify(message.depthChanged);
                if (error)
                    return "depthChanged." + error;
            }
        }
        if (message.gainChanged != null && message.hasOwnProperty("gainChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.GainChanged.verify(message.gainChanged);
                if (error)
                    return "gainChanged." + error;
            }
        }
        if (message.presetChanged != null && message.hasOwnProperty("presetChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.PresetChanged.verify(message.presetChanged);
                if (error)
                    return "presetChanged." + error;
            }
        }
        if (message.cameraModeChanged != null && message.hasOwnProperty("cameraModeChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.CameraModeChanged.verify(message.cameraModeChanged);
                if (error)
                    return "cameraModeChanged." + error;
            }
        }
        if (message.probeStateChanged != null && message.hasOwnProperty("probeStateChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.ProbeStateChanged.verify(message.probeStateChanged);
                if (error)
                    return "probeStateChanged." + error;
            }
        }
        if (message.temperatureStateChanged != null && message.hasOwnProperty("temperatureStateChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.TemperatureStateChanged.verify(message.temperatureStateChanged);
                if (error)
                    return "temperatureStateChanged." + error;
            }
        }
        if (message.currentSettings != null && message.hasOwnProperty("currentSettings")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.CurrentSettings.verify(message.currentSettings);
                if (error)
                    return "currentSettings." + error;
            }
        }
        if (message.disconnected != null && message.hasOwnProperty("disconnected")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.Disconnected.verify(message.disconnected);
                if (error)
                    return "disconnected." + error;
            }
        }
        if (message.cineCaptureStarted != null && message.hasOwnProperty("cineCaptureStarted")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.Empty.verify(message.cineCaptureStarted);
                if (error)
                    return "cineCaptureStarted." + error;
            }
        }
        if (message.cineCaptureStopped != null && message.hasOwnProperty("cineCaptureStopped")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.Empty.verify(message.cineCaptureStopped);
                if (error)
                    return "cineCaptureStopped." + error;
            }
        }
        if (message.cineCaptureCancelled != null && message.hasOwnProperty("cineCaptureCancelled")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.Empty.verify(message.cineCaptureCancelled);
                if (error)
                    return "cineCaptureCancelled." + error;
            }
        }
        if (message.stillCaptured != null && message.hasOwnProperty("stillCaptured")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.Empty.verify(message.stillCaptured);
                if (error)
                    return "stillCaptured." + error;
            }
        }
        if (message.probeDimension != null && message.hasOwnProperty("probeDimension")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.VideoDimension.verify(message.probeDimension);
                if (error)
                    return "probeDimension." + error;
            }
        }
        if (message.cameraDimension != null && message.hasOwnProperty("cameraDimension")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.VideoDimension.verify(message.cameraDimension);
                if (error)
                    return "cameraDimension." + error;
            }
        }
        if (message.batteryStateChanged != null && message.hasOwnProperty("batteryStateChanged")) {
            if (properties.event === 1)
                return "event: multiple values";
            properties.event = 1;
            {
                var error = $root.HeliosEvent.BatteryStateChanged.verify(message.batteryStateChanged);
                if (error)
                    return "batteryStateChanged." + error;
            }
        }
        return null;
    };

    /**
     * Creates a HeliosEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HeliosEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HeliosEvent} HeliosEvent
     */
    HeliosEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.HeliosEvent)
            return object;
        var message = new $root.HeliosEvent();
        if (object.ack != null) {
            if (typeof object.ack !== "object")
                throw TypeError(".HeliosEvent.ack: object expected");
            message.ack = $root.Acknowledgement.fromObject(object.ack);
        }
        if (object.pose != null) {
            if (typeof object.pose !== "object")
                throw TypeError(".HeliosEvent.pose: object expected");
            message.pose = $root.HeliosEvent.Pose.fromObject(object.pose);
        }
        if (object.freezeChanged != null) {
            if (typeof object.freezeChanged !== "object")
                throw TypeError(".HeliosEvent.freezeChanged: object expected");
            message.freezeChanged = $root.HeliosEvent.FreezeChanged.fromObject(object.freezeChanged);
        }
        if (object.modeChanged != null) {
            if (typeof object.modeChanged !== "object")
                throw TypeError(".HeliosEvent.modeChanged: object expected");
            message.modeChanged = $root.HeliosEvent.ModeChanged.fromObject(object.modeChanged);
        }
        if (object.depthChanged != null) {
            if (typeof object.depthChanged !== "object")
                throw TypeError(".HeliosEvent.depthChanged: object expected");
            message.depthChanged = $root.HeliosEvent.DepthChanged.fromObject(object.depthChanged);
        }
        if (object.gainChanged != null) {
            if (typeof object.gainChanged !== "object")
                throw TypeError(".HeliosEvent.gainChanged: object expected");
            message.gainChanged = $root.HeliosEvent.GainChanged.fromObject(object.gainChanged);
        }
        if (object.presetChanged != null) {
            if (typeof object.presetChanged !== "object")
                throw TypeError(".HeliosEvent.presetChanged: object expected");
            message.presetChanged = $root.HeliosEvent.PresetChanged.fromObject(object.presetChanged);
        }
        if (object.cameraModeChanged != null) {
            if (typeof object.cameraModeChanged !== "object")
                throw TypeError(".HeliosEvent.cameraModeChanged: object expected");
            message.cameraModeChanged = $root.HeliosEvent.CameraModeChanged.fromObject(object.cameraModeChanged);
        }
        if (object.probeStateChanged != null) {
            if (typeof object.probeStateChanged !== "object")
                throw TypeError(".HeliosEvent.probeStateChanged: object expected");
            message.probeStateChanged = $root.HeliosEvent.ProbeStateChanged.fromObject(object.probeStateChanged);
        }
        if (object.temperatureStateChanged != null) {
            if (typeof object.temperatureStateChanged !== "object")
                throw TypeError(".HeliosEvent.temperatureStateChanged: object expected");
            message.temperatureStateChanged = $root.HeliosEvent.TemperatureStateChanged.fromObject(object.temperatureStateChanged);
        }
        if (object.currentSettings != null) {
            if (typeof object.currentSettings !== "object")
                throw TypeError(".HeliosEvent.currentSettings: object expected");
            message.currentSettings = $root.HeliosEvent.CurrentSettings.fromObject(object.currentSettings);
        }
        if (object.disconnected != null) {
            if (typeof object.disconnected !== "object")
                throw TypeError(".HeliosEvent.disconnected: object expected");
            message.disconnected = $root.HeliosEvent.Disconnected.fromObject(object.disconnected);
        }
        if (object.cineCaptureStarted != null) {
            if (typeof object.cineCaptureStarted !== "object")
                throw TypeError(".HeliosEvent.cineCaptureStarted: object expected");
            message.cineCaptureStarted = $root.Empty.fromObject(object.cineCaptureStarted);
        }
        if (object.cineCaptureStopped != null) {
            if (typeof object.cineCaptureStopped !== "object")
                throw TypeError(".HeliosEvent.cineCaptureStopped: object expected");
            message.cineCaptureStopped = $root.Empty.fromObject(object.cineCaptureStopped);
        }
        if (object.cineCaptureCancelled != null) {
            if (typeof object.cineCaptureCancelled !== "object")
                throw TypeError(".HeliosEvent.cineCaptureCancelled: object expected");
            message.cineCaptureCancelled = $root.Empty.fromObject(object.cineCaptureCancelled);
        }
        if (object.stillCaptured != null) {
            if (typeof object.stillCaptured !== "object")
                throw TypeError(".HeliosEvent.stillCaptured: object expected");
            message.stillCaptured = $root.Empty.fromObject(object.stillCaptured);
        }
        if (object.probeDimension != null) {
            if (typeof object.probeDimension !== "object")
                throw TypeError(".HeliosEvent.probeDimension: object expected");
            message.probeDimension = $root.HeliosEvent.VideoDimension.fromObject(object.probeDimension);
        }
        if (object.cameraDimension != null) {
            if (typeof object.cameraDimension !== "object")
                throw TypeError(".HeliosEvent.cameraDimension: object expected");
            message.cameraDimension = $root.HeliosEvent.VideoDimension.fromObject(object.cameraDimension);
        }
        if (object.batteryStateChanged != null) {
            if (typeof object.batteryStateChanged !== "object")
                throw TypeError(".HeliosEvent.batteryStateChanged: object expected");
            message.batteryStateChanged = $root.HeliosEvent.BatteryStateChanged.fromObject(object.batteryStateChanged);
        }
        return message;
    };

    /**
     * Creates a plain object from a HeliosEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HeliosEvent
     * @static
     * @param {HeliosEvent} message HeliosEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HeliosEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (message.ack != null && message.hasOwnProperty("ack")) {
            object.ack = $root.Acknowledgement.toObject(message.ack, options);
            if (options.oneofs)
                object.event = "ack";
        }
        if (message.pose != null && message.hasOwnProperty("pose")) {
            object.pose = $root.HeliosEvent.Pose.toObject(message.pose, options);
            if (options.oneofs)
                object.event = "pose";
        }
        if (message.freezeChanged != null && message.hasOwnProperty("freezeChanged")) {
            object.freezeChanged = $root.HeliosEvent.FreezeChanged.toObject(message.freezeChanged, options);
            if (options.oneofs)
                object.event = "freezeChanged";
        }
        if (message.modeChanged != null && message.hasOwnProperty("modeChanged")) {
            object.modeChanged = $root.HeliosEvent.ModeChanged.toObject(message.modeChanged, options);
            if (options.oneofs)
                object.event = "modeChanged";
        }
        if (message.depthChanged != null && message.hasOwnProperty("depthChanged")) {
            object.depthChanged = $root.HeliosEvent.DepthChanged.toObject(message.depthChanged, options);
            if (options.oneofs)
                object.event = "depthChanged";
        }
        if (message.gainChanged != null && message.hasOwnProperty("gainChanged")) {
            object.gainChanged = $root.HeliosEvent.GainChanged.toObject(message.gainChanged, options);
            if (options.oneofs)
                object.event = "gainChanged";
        }
        if (message.presetChanged != null && message.hasOwnProperty("presetChanged")) {
            object.presetChanged = $root.HeliosEvent.PresetChanged.toObject(message.presetChanged, options);
            if (options.oneofs)
                object.event = "presetChanged";
        }
        if (message.cameraModeChanged != null && message.hasOwnProperty("cameraModeChanged")) {
            object.cameraModeChanged = $root.HeliosEvent.CameraModeChanged.toObject(message.cameraModeChanged, options);
            if (options.oneofs)
                object.event = "cameraModeChanged";
        }
        if (message.probeStateChanged != null && message.hasOwnProperty("probeStateChanged")) {
            object.probeStateChanged = $root.HeliosEvent.ProbeStateChanged.toObject(message.probeStateChanged, options);
            if (options.oneofs)
                object.event = "probeStateChanged";
        }
        if (message.temperatureStateChanged != null && message.hasOwnProperty("temperatureStateChanged")) {
            object.temperatureStateChanged = $root.HeliosEvent.TemperatureStateChanged.toObject(message.temperatureStateChanged, options);
            if (options.oneofs)
                object.event = "temperatureStateChanged";
        }
        if (message.currentSettings != null && message.hasOwnProperty("currentSettings")) {
            object.currentSettings = $root.HeliosEvent.CurrentSettings.toObject(message.currentSettings, options);
            if (options.oneofs)
                object.event = "currentSettings";
        }
        if (message.disconnected != null && message.hasOwnProperty("disconnected")) {
            object.disconnected = $root.HeliosEvent.Disconnected.toObject(message.disconnected, options);
            if (options.oneofs)
                object.event = "disconnected";
        }
        if (message.cineCaptureStarted != null && message.hasOwnProperty("cineCaptureStarted")) {
            object.cineCaptureStarted = $root.Empty.toObject(message.cineCaptureStarted, options);
            if (options.oneofs)
                object.event = "cineCaptureStarted";
        }
        if (message.cineCaptureStopped != null && message.hasOwnProperty("cineCaptureStopped")) {
            object.cineCaptureStopped = $root.Empty.toObject(message.cineCaptureStopped, options);
            if (options.oneofs)
                object.event = "cineCaptureStopped";
        }
        if (message.cineCaptureCancelled != null && message.hasOwnProperty("cineCaptureCancelled")) {
            object.cineCaptureCancelled = $root.Empty.toObject(message.cineCaptureCancelled, options);
            if (options.oneofs)
                object.event = "cineCaptureCancelled";
        }
        if (message.stillCaptured != null && message.hasOwnProperty("stillCaptured")) {
            object.stillCaptured = $root.Empty.toObject(message.stillCaptured, options);
            if (options.oneofs)
                object.event = "stillCaptured";
        }
        if (message.probeDimension != null && message.hasOwnProperty("probeDimension")) {
            object.probeDimension = $root.HeliosEvent.VideoDimension.toObject(message.probeDimension, options);
            if (options.oneofs)
                object.event = "probeDimension";
        }
        if (message.cameraDimension != null && message.hasOwnProperty("cameraDimension")) {
            object.cameraDimension = $root.HeliosEvent.VideoDimension.toObject(message.cameraDimension, options);
            if (options.oneofs)
                object.event = "cameraDimension";
        }
        if (message.batteryStateChanged != null && message.hasOwnProperty("batteryStateChanged")) {
            object.batteryStateChanged = $root.HeliosEvent.BatteryStateChanged.toObject(message.batteryStateChanged, options);
            if (options.oneofs)
                object.event = "batteryStateChanged";
        }
        return object;
    };

    /**
     * Converts this HeliosEvent to JSON.
     * @function toJSON
     * @memberof HeliosEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HeliosEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    HeliosEvent.Pose = (function() {

        /**
         * Properties of a Pose.
         * @memberof HeliosEvent
         * @interface IPose
         * @property {HeliosEvent.Pose.IEstimation|null} [estimation] Pose estimation
         * @property {boolean|null} [stale] Pose stale
         */

        /**
         * Constructs a new Pose.
         * @memberof HeliosEvent
         * @classdesc Represents a Pose.
         * @implements IPose
         * @constructor
         * @param {HeliosEvent.IPose=} [properties] Properties to set
         */
        function Pose(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pose estimation.
         * @member {HeliosEvent.Pose.IEstimation|null|undefined} estimation
         * @memberof HeliosEvent.Pose
         * @instance
         */
        Pose.prototype.estimation = null;

        /**
         * Pose stale.
         * @member {boolean} stale
         * @memberof HeliosEvent.Pose
         * @instance
         */
        Pose.prototype.stale = false;

        /**
         * Creates a new Pose instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.Pose
         * @static
         * @param {HeliosEvent.IPose=} [properties] Properties to set
         * @returns {HeliosEvent.Pose} Pose instance
         */
        Pose.create = function create(properties) {
            return new Pose(properties);
        };

        /**
         * Encodes the specified Pose message. Does not implicitly {@link HeliosEvent.Pose.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.Pose
         * @static
         * @param {HeliosEvent.IPose} message Pose message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pose.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.estimation != null && message.hasOwnProperty("estimation"))
                $root.HeliosEvent.Pose.Estimation.encode(message.estimation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.stale != null && message.hasOwnProperty("stale"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.stale);
            return writer;
        };

        /**
         * Encodes the specified Pose message, length delimited. Does not implicitly {@link HeliosEvent.Pose.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.Pose
         * @static
         * @param {HeliosEvent.IPose} message Pose message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pose.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Pose message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.Pose
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.Pose} Pose
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pose.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Pose();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.estimation = $root.HeliosEvent.Pose.Estimation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.stale = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Pose message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.Pose
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.Pose} Pose
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pose.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Pose message.
         * @function verify
         * @memberof HeliosEvent.Pose
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Pose.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.estimation != null && message.hasOwnProperty("estimation")) {
                var error = $root.HeliosEvent.Pose.Estimation.verify(message.estimation);
                if (error)
                    return "estimation." + error;
            }
            if (message.stale != null && message.hasOwnProperty("stale"))
                if (typeof message.stale !== "boolean")
                    return "stale: boolean expected";
            return null;
        };

        /**
         * Creates a Pose message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.Pose
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.Pose} Pose
         */
        Pose.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.Pose)
                return object;
            var message = new $root.HeliosEvent.Pose();
            if (object.estimation != null) {
                if (typeof object.estimation !== "object")
                    throw TypeError(".HeliosEvent.Pose.estimation: object expected");
                message.estimation = $root.HeliosEvent.Pose.Estimation.fromObject(object.estimation);
            }
            if (object.stale != null)
                message.stale = Boolean(object.stale);
            return message;
        };

        /**
         * Creates a plain object from a Pose message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.Pose
         * @static
         * @param {HeliosEvent.Pose} message Pose
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pose.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.estimation = null;
                object.stale = false;
            }
            if (message.estimation != null && message.hasOwnProperty("estimation"))
                object.estimation = $root.HeliosEvent.Pose.Estimation.toObject(message.estimation, options);
            if (message.stale != null && message.hasOwnProperty("stale"))
                object.stale = message.stale;
            return object;
        };

        /**
         * Converts this Pose to JSON.
         * @function toJSON
         * @memberof HeliosEvent.Pose
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pose.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Pose.Rotation = (function() {

            /**
             * Properties of a Rotation.
             * @memberof HeliosEvent.Pose
             * @interface IRotation
             * @property {number|null} [m11] Rotation m11
             * @property {number|null} [m12] Rotation m12
             * @property {number|null} [m13] Rotation m13
             * @property {number|null} [m21] Rotation m21
             * @property {number|null} [m22] Rotation m22
             * @property {number|null} [m23] Rotation m23
             * @property {number|null} [m31] Rotation m31
             * @property {number|null} [m32] Rotation m32
             * @property {number|null} [m33] Rotation m33
             */

            /**
             * Constructs a new Rotation.
             * @memberof HeliosEvent.Pose
             * @classdesc Represents a Rotation.
             * @implements IRotation
             * @constructor
             * @param {HeliosEvent.Pose.IRotation=} [properties] Properties to set
             */
            function Rotation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Rotation m11.
             * @member {number} m11
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m11 = 0;

            /**
             * Rotation m12.
             * @member {number} m12
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m12 = 0;

            /**
             * Rotation m13.
             * @member {number} m13
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m13 = 0;

            /**
             * Rotation m21.
             * @member {number} m21
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m21 = 0;

            /**
             * Rotation m22.
             * @member {number} m22
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m22 = 0;

            /**
             * Rotation m23.
             * @member {number} m23
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m23 = 0;

            /**
             * Rotation m31.
             * @member {number} m31
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m31 = 0;

            /**
             * Rotation m32.
             * @member {number} m32
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m32 = 0;

            /**
             * Rotation m33.
             * @member {number} m33
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             */
            Rotation.prototype.m33 = 0;

            /**
             * Creates a new Rotation instance using the specified properties.
             * @function create
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {HeliosEvent.Pose.IRotation=} [properties] Properties to set
             * @returns {HeliosEvent.Pose.Rotation} Rotation instance
             */
            Rotation.create = function create(properties) {
                return new Rotation(properties);
            };

            /**
             * Encodes the specified Rotation message. Does not implicitly {@link HeliosEvent.Pose.Rotation.verify|verify} messages.
             * @function encode
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {HeliosEvent.Pose.IRotation} message Rotation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Rotation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.m11 != null && message.hasOwnProperty("m11"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.m11);
                if (message.m12 != null && message.hasOwnProperty("m12"))
                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.m12);
                if (message.m13 != null && message.hasOwnProperty("m13"))
                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.m13);
                if (message.m21 != null && message.hasOwnProperty("m21"))
                    writer.uint32(/* id 4, wireType 5 =*/37).float(message.m21);
                if (message.m22 != null && message.hasOwnProperty("m22"))
                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.m22);
                if (message.m23 != null && message.hasOwnProperty("m23"))
                    writer.uint32(/* id 6, wireType 5 =*/53).float(message.m23);
                if (message.m31 != null && message.hasOwnProperty("m31"))
                    writer.uint32(/* id 7, wireType 5 =*/61).float(message.m31);
                if (message.m32 != null && message.hasOwnProperty("m32"))
                    writer.uint32(/* id 8, wireType 5 =*/69).float(message.m32);
                if (message.m33 != null && message.hasOwnProperty("m33"))
                    writer.uint32(/* id 9, wireType 5 =*/77).float(message.m33);
                return writer;
            };

            /**
             * Encodes the specified Rotation message, length delimited. Does not implicitly {@link HeliosEvent.Pose.Rotation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {HeliosEvent.Pose.IRotation} message Rotation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Rotation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Rotation message from the specified reader or buffer.
             * @function decode
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {HeliosEvent.Pose.Rotation} Rotation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Rotation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Pose.Rotation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.m11 = reader.float();
                        break;
                    case 2:
                        message.m12 = reader.float();
                        break;
                    case 3:
                        message.m13 = reader.float();
                        break;
                    case 4:
                        message.m21 = reader.float();
                        break;
                    case 5:
                        message.m22 = reader.float();
                        break;
                    case 6:
                        message.m23 = reader.float();
                        break;
                    case 7:
                        message.m31 = reader.float();
                        break;
                    case 8:
                        message.m32 = reader.float();
                        break;
                    case 9:
                        message.m33 = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Rotation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {HeliosEvent.Pose.Rotation} Rotation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Rotation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Rotation message.
             * @function verify
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Rotation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.m11 != null && message.hasOwnProperty("m11"))
                    if (typeof message.m11 !== "number")
                        return "m11: number expected";
                if (message.m12 != null && message.hasOwnProperty("m12"))
                    if (typeof message.m12 !== "number")
                        return "m12: number expected";
                if (message.m13 != null && message.hasOwnProperty("m13"))
                    if (typeof message.m13 !== "number")
                        return "m13: number expected";
                if (message.m21 != null && message.hasOwnProperty("m21"))
                    if (typeof message.m21 !== "number")
                        return "m21: number expected";
                if (message.m22 != null && message.hasOwnProperty("m22"))
                    if (typeof message.m22 !== "number")
                        return "m22: number expected";
                if (message.m23 != null && message.hasOwnProperty("m23"))
                    if (typeof message.m23 !== "number")
                        return "m23: number expected";
                if (message.m31 != null && message.hasOwnProperty("m31"))
                    if (typeof message.m31 !== "number")
                        return "m31: number expected";
                if (message.m32 != null && message.hasOwnProperty("m32"))
                    if (typeof message.m32 !== "number")
                        return "m32: number expected";
                if (message.m33 != null && message.hasOwnProperty("m33"))
                    if (typeof message.m33 !== "number")
                        return "m33: number expected";
                return null;
            };

            /**
             * Creates a Rotation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {HeliosEvent.Pose.Rotation} Rotation
             */
            Rotation.fromObject = function fromObject(object) {
                if (object instanceof $root.HeliosEvent.Pose.Rotation)
                    return object;
                var message = new $root.HeliosEvent.Pose.Rotation();
                if (object.m11 != null)
                    message.m11 = Number(object.m11);
                if (object.m12 != null)
                    message.m12 = Number(object.m12);
                if (object.m13 != null)
                    message.m13 = Number(object.m13);
                if (object.m21 != null)
                    message.m21 = Number(object.m21);
                if (object.m22 != null)
                    message.m22 = Number(object.m22);
                if (object.m23 != null)
                    message.m23 = Number(object.m23);
                if (object.m31 != null)
                    message.m31 = Number(object.m31);
                if (object.m32 != null)
                    message.m32 = Number(object.m32);
                if (object.m33 != null)
                    message.m33 = Number(object.m33);
                return message;
            };

            /**
             * Creates a plain object from a Rotation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof HeliosEvent.Pose.Rotation
             * @static
             * @param {HeliosEvent.Pose.Rotation} message Rotation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Rotation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.m11 = 0;
                    object.m12 = 0;
                    object.m13 = 0;
                    object.m21 = 0;
                    object.m22 = 0;
                    object.m23 = 0;
                    object.m31 = 0;
                    object.m32 = 0;
                    object.m33 = 0;
                }
                if (message.m11 != null && message.hasOwnProperty("m11"))
                    object.m11 = options.json && !isFinite(message.m11) ? String(message.m11) : message.m11;
                if (message.m12 != null && message.hasOwnProperty("m12"))
                    object.m12 = options.json && !isFinite(message.m12) ? String(message.m12) : message.m12;
                if (message.m13 != null && message.hasOwnProperty("m13"))
                    object.m13 = options.json && !isFinite(message.m13) ? String(message.m13) : message.m13;
                if (message.m21 != null && message.hasOwnProperty("m21"))
                    object.m21 = options.json && !isFinite(message.m21) ? String(message.m21) : message.m21;
                if (message.m22 != null && message.hasOwnProperty("m22"))
                    object.m22 = options.json && !isFinite(message.m22) ? String(message.m22) : message.m22;
                if (message.m23 != null && message.hasOwnProperty("m23"))
                    object.m23 = options.json && !isFinite(message.m23) ? String(message.m23) : message.m23;
                if (message.m31 != null && message.hasOwnProperty("m31"))
                    object.m31 = options.json && !isFinite(message.m31) ? String(message.m31) : message.m31;
                if (message.m32 != null && message.hasOwnProperty("m32"))
                    object.m32 = options.json && !isFinite(message.m32) ? String(message.m32) : message.m32;
                if (message.m33 != null && message.hasOwnProperty("m33"))
                    object.m33 = options.json && !isFinite(message.m33) ? String(message.m33) : message.m33;
                return object;
            };

            /**
             * Converts this Rotation to JSON.
             * @function toJSON
             * @memberof HeliosEvent.Pose.Rotation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Rotation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Rotation;
        })();

        Pose.Translation = (function() {

            /**
             * Properties of a Translation.
             * @memberof HeliosEvent.Pose
             * @interface ITranslation
             * @property {number|null} [x] Translation x
             * @property {number|null} [y] Translation y
             * @property {number|null} [z] Translation z
             */

            /**
             * Constructs a new Translation.
             * @memberof HeliosEvent.Pose
             * @classdesc Represents a Translation.
             * @implements ITranslation
             * @constructor
             * @param {HeliosEvent.Pose.ITranslation=} [properties] Properties to set
             */
            function Translation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Translation x.
             * @member {number} x
             * @memberof HeliosEvent.Pose.Translation
             * @instance
             */
            Translation.prototype.x = 0;

            /**
             * Translation y.
             * @member {number} y
             * @memberof HeliosEvent.Pose.Translation
             * @instance
             */
            Translation.prototype.y = 0;

            /**
             * Translation z.
             * @member {number} z
             * @memberof HeliosEvent.Pose.Translation
             * @instance
             */
            Translation.prototype.z = 0;

            /**
             * Creates a new Translation instance using the specified properties.
             * @function create
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {HeliosEvent.Pose.ITranslation=} [properties] Properties to set
             * @returns {HeliosEvent.Pose.Translation} Translation instance
             */
            Translation.create = function create(properties) {
                return new Translation(properties);
            };

            /**
             * Encodes the specified Translation message. Does not implicitly {@link HeliosEvent.Pose.Translation.verify|verify} messages.
             * @function encode
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {HeliosEvent.Pose.ITranslation} message Translation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Translation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.x != null && message.hasOwnProperty("x"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                if (message.y != null && message.hasOwnProperty("y"))
                    writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                if (message.z != null && message.hasOwnProperty("z"))
                    writer.uint32(/* id 3, wireType 5 =*/29).float(message.z);
                return writer;
            };

            /**
             * Encodes the specified Translation message, length delimited. Does not implicitly {@link HeliosEvent.Pose.Translation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {HeliosEvent.Pose.ITranslation} message Translation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Translation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Translation message from the specified reader or buffer.
             * @function decode
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {HeliosEvent.Pose.Translation} Translation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Translation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Pose.Translation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.x = reader.float();
                        break;
                    case 2:
                        message.y = reader.float();
                        break;
                    case 3:
                        message.z = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Translation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {HeliosEvent.Pose.Translation} Translation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Translation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Translation message.
             * @function verify
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Translation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.x != null && message.hasOwnProperty("x"))
                    if (typeof message.x !== "number")
                        return "x: number expected";
                if (message.y != null && message.hasOwnProperty("y"))
                    if (typeof message.y !== "number")
                        return "y: number expected";
                if (message.z != null && message.hasOwnProperty("z"))
                    if (typeof message.z !== "number")
                        return "z: number expected";
                return null;
            };

            /**
             * Creates a Translation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {HeliosEvent.Pose.Translation} Translation
             */
            Translation.fromObject = function fromObject(object) {
                if (object instanceof $root.HeliosEvent.Pose.Translation)
                    return object;
                var message = new $root.HeliosEvent.Pose.Translation();
                if (object.x != null)
                    message.x = Number(object.x);
                if (object.y != null)
                    message.y = Number(object.y);
                if (object.z != null)
                    message.z = Number(object.z);
                return message;
            };

            /**
             * Creates a plain object from a Translation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof HeliosEvent.Pose.Translation
             * @static
             * @param {HeliosEvent.Pose.Translation} message Translation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Translation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.x = 0;
                    object.y = 0;
                    object.z = 0;
                }
                if (message.x != null && message.hasOwnProperty("x"))
                    object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                if (message.y != null && message.hasOwnProperty("y"))
                    object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                if (message.z != null && message.hasOwnProperty("z"))
                    object.z = options.json && !isFinite(message.z) ? String(message.z) : message.z;
                return object;
            };

            /**
             * Converts this Translation to JSON.
             * @function toJSON
             * @memberof HeliosEvent.Pose.Translation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Translation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Translation;
        })();

        Pose.Estimation = (function() {

            /**
             * Properties of an Estimation.
             * @memberof HeliosEvent.Pose
             * @interface IEstimation
             * @property {HeliosEvent.Pose.IRotation|null} [rotation] Estimation rotation
             * @property {HeliosEvent.Pose.ITranslation|null} [translation] Estimation translation
             */

            /**
             * Constructs a new Estimation.
             * @memberof HeliosEvent.Pose
             * @classdesc Represents an Estimation.
             * @implements IEstimation
             * @constructor
             * @param {HeliosEvent.Pose.IEstimation=} [properties] Properties to set
             */
            function Estimation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Estimation rotation.
             * @member {HeliosEvent.Pose.IRotation|null|undefined} rotation
             * @memberof HeliosEvent.Pose.Estimation
             * @instance
             */
            Estimation.prototype.rotation = null;

            /**
             * Estimation translation.
             * @member {HeliosEvent.Pose.ITranslation|null|undefined} translation
             * @memberof HeliosEvent.Pose.Estimation
             * @instance
             */
            Estimation.prototype.translation = null;

            /**
             * Creates a new Estimation instance using the specified properties.
             * @function create
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {HeliosEvent.Pose.IEstimation=} [properties] Properties to set
             * @returns {HeliosEvent.Pose.Estimation} Estimation instance
             */
            Estimation.create = function create(properties) {
                return new Estimation(properties);
            };

            /**
             * Encodes the specified Estimation message. Does not implicitly {@link HeliosEvent.Pose.Estimation.verify|verify} messages.
             * @function encode
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {HeliosEvent.Pose.IEstimation} message Estimation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Estimation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.rotation != null && message.hasOwnProperty("rotation"))
                    $root.HeliosEvent.Pose.Rotation.encode(message.rotation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.translation != null && message.hasOwnProperty("translation"))
                    $root.HeliosEvent.Pose.Translation.encode(message.translation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Estimation message, length delimited. Does not implicitly {@link HeliosEvent.Pose.Estimation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {HeliosEvent.Pose.IEstimation} message Estimation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Estimation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Estimation message from the specified reader or buffer.
             * @function decode
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {HeliosEvent.Pose.Estimation} Estimation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Estimation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Pose.Estimation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.rotation = $root.HeliosEvent.Pose.Rotation.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.translation = $root.HeliosEvent.Pose.Translation.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Estimation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {HeliosEvent.Pose.Estimation} Estimation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Estimation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Estimation message.
             * @function verify
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Estimation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.rotation != null && message.hasOwnProperty("rotation")) {
                    var error = $root.HeliosEvent.Pose.Rotation.verify(message.rotation);
                    if (error)
                        return "rotation." + error;
                }
                if (message.translation != null && message.hasOwnProperty("translation")) {
                    var error = $root.HeliosEvent.Pose.Translation.verify(message.translation);
                    if (error)
                        return "translation." + error;
                }
                return null;
            };

            /**
             * Creates an Estimation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {HeliosEvent.Pose.Estimation} Estimation
             */
            Estimation.fromObject = function fromObject(object) {
                if (object instanceof $root.HeliosEvent.Pose.Estimation)
                    return object;
                var message = new $root.HeliosEvent.Pose.Estimation();
                if (object.rotation != null) {
                    if (typeof object.rotation !== "object")
                        throw TypeError(".HeliosEvent.Pose.Estimation.rotation: object expected");
                    message.rotation = $root.HeliosEvent.Pose.Rotation.fromObject(object.rotation);
                }
                if (object.translation != null) {
                    if (typeof object.translation !== "object")
                        throw TypeError(".HeliosEvent.Pose.Estimation.translation: object expected");
                    message.translation = $root.HeliosEvent.Pose.Translation.fromObject(object.translation);
                }
                return message;
            };

            /**
             * Creates a plain object from an Estimation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof HeliosEvent.Pose.Estimation
             * @static
             * @param {HeliosEvent.Pose.Estimation} message Estimation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Estimation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.rotation = null;
                    object.translation = null;
                }
                if (message.rotation != null && message.hasOwnProperty("rotation"))
                    object.rotation = $root.HeliosEvent.Pose.Rotation.toObject(message.rotation, options);
                if (message.translation != null && message.hasOwnProperty("translation"))
                    object.translation = $root.HeliosEvent.Pose.Translation.toObject(message.translation, options);
                return object;
            };

            /**
             * Converts this Estimation to JSON.
             * @function toJSON
             * @memberof HeliosEvent.Pose.Estimation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Estimation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Estimation;
        })();

        return Pose;
    })();

    HeliosEvent.Disconnected = (function() {

        /**
         * Properties of a Disconnected.
         * @memberof HeliosEvent
         * @interface IDisconnected
         * @property {boolean|null} [temporary] Disconnected temporary
         */

        /**
         * Constructs a new Disconnected.
         * @memberof HeliosEvent
         * @classdesc Represents a Disconnected.
         * @implements IDisconnected
         * @constructor
         * @param {HeliosEvent.IDisconnected=} [properties] Properties to set
         */
        function Disconnected(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Disconnected temporary.
         * @member {boolean} temporary
         * @memberof HeliosEvent.Disconnected
         * @instance
         */
        Disconnected.prototype.temporary = false;

        /**
         * Creates a new Disconnected instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {HeliosEvent.IDisconnected=} [properties] Properties to set
         * @returns {HeliosEvent.Disconnected} Disconnected instance
         */
        Disconnected.create = function create(properties) {
            return new Disconnected(properties);
        };

        /**
         * Encodes the specified Disconnected message. Does not implicitly {@link HeliosEvent.Disconnected.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {HeliosEvent.IDisconnected} message Disconnected message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Disconnected.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.temporary != null && message.hasOwnProperty("temporary"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.temporary);
            return writer;
        };

        /**
         * Encodes the specified Disconnected message, length delimited. Does not implicitly {@link HeliosEvent.Disconnected.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {HeliosEvent.IDisconnected} message Disconnected message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Disconnected.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Disconnected message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.Disconnected} Disconnected
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Disconnected.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Disconnected();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.temporary = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Disconnected message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.Disconnected} Disconnected
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Disconnected.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Disconnected message.
         * @function verify
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Disconnected.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.temporary != null && message.hasOwnProperty("temporary"))
                if (typeof message.temporary !== "boolean")
                    return "temporary: boolean expected";
            return null;
        };

        /**
         * Creates a Disconnected message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.Disconnected} Disconnected
         */
        Disconnected.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.Disconnected)
                return object;
            var message = new $root.HeliosEvent.Disconnected();
            if (object.temporary != null)
                message.temporary = Boolean(object.temporary);
            return message;
        };

        /**
         * Creates a plain object from a Disconnected message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.Disconnected
         * @static
         * @param {HeliosEvent.Disconnected} message Disconnected
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Disconnected.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.temporary = false;
            if (message.temporary != null && message.hasOwnProperty("temporary"))
                object.temporary = message.temporary;
            return object;
        };

        /**
         * Converts this Disconnected to JSON.
         * @function toJSON
         * @memberof HeliosEvent.Disconnected
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Disconnected.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Disconnected;
    })();

    HeliosEvent.ProbeStateChanged = (function() {

        /**
         * Properties of a ProbeStateChanged.
         * @memberof HeliosEvent
         * @interface IProbeStateChanged
         * @property {ProbeState|null} [value] ProbeStateChanged value
         */

        /**
         * Constructs a new ProbeStateChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a ProbeStateChanged.
         * @implements IProbeStateChanged
         * @constructor
         * @param {HeliosEvent.IProbeStateChanged=} [properties] Properties to set
         */
        function ProbeStateChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProbeStateChanged value.
         * @member {ProbeState} value
         * @memberof HeliosEvent.ProbeStateChanged
         * @instance
         */
        ProbeStateChanged.prototype.value = 0;

        /**
         * Creates a new ProbeStateChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {HeliosEvent.IProbeStateChanged=} [properties] Properties to set
         * @returns {HeliosEvent.ProbeStateChanged} ProbeStateChanged instance
         */
        ProbeStateChanged.create = function create(properties) {
            return new ProbeStateChanged(properties);
        };

        /**
         * Encodes the specified ProbeStateChanged message. Does not implicitly {@link HeliosEvent.ProbeStateChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {HeliosEvent.IProbeStateChanged} message ProbeStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProbeStateChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
            return writer;
        };

        /**
         * Encodes the specified ProbeStateChanged message, length delimited. Does not implicitly {@link HeliosEvent.ProbeStateChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {HeliosEvent.IProbeStateChanged} message ProbeStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProbeStateChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProbeStateChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.ProbeStateChanged} ProbeStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProbeStateChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.ProbeStateChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProbeStateChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.ProbeStateChanged} ProbeStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProbeStateChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProbeStateChanged message.
         * @function verify
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProbeStateChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                switch (message.value) {
                default:
                    return "value: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            return null;
        };

        /**
         * Creates a ProbeStateChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.ProbeStateChanged} ProbeStateChanged
         */
        ProbeStateChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.ProbeStateChanged)
                return object;
            var message = new $root.HeliosEvent.ProbeStateChanged();
            switch (object.value) {
            case "UNKNOWN_PROBE":
            case 0:
                message.value = 0;
                break;
            case "CHARGING":
            case 1:
                message.value = 1;
                break;
            case "CONNECTED":
            case 2:
                message.value = 2;
                break;
            case "DISCONNECTED":
            case 3:
                message.value = 3;
                break;
            case "HARDWARE_INCOMPATIBLE":
            case 4:
                message.value = 4;
                break;
            case "FIRMWARE_INCOMPATIBLE":
            case 5:
                message.value = 5;
                break;
            case "NOT_READY":
            case 6:
                message.value = 6;
                break;
            case "READY":
            case 7:
                message.value = 7;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ProbeStateChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.ProbeStateChanged
         * @static
         * @param {HeliosEvent.ProbeStateChanged} message ProbeStateChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProbeStateChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = options.enums === String ? "UNKNOWN_PROBE" : 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.enums === String ? $root.ProbeState[message.value] : message.value;
            return object;
        };

        /**
         * Converts this ProbeStateChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.ProbeStateChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProbeStateChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ProbeStateChanged;
    })();

    HeliosEvent.TemperatureStateChanged = (function() {

        /**
         * Properties of a TemperatureStateChanged.
         * @memberof HeliosEvent
         * @interface ITemperatureStateChanged
         * @property {TemperatureState|null} [value] TemperatureStateChanged value
         */

        /**
         * Constructs a new TemperatureStateChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a TemperatureStateChanged.
         * @implements ITemperatureStateChanged
         * @constructor
         * @param {HeliosEvent.ITemperatureStateChanged=} [properties] Properties to set
         */
        function TemperatureStateChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TemperatureStateChanged value.
         * @member {TemperatureState} value
         * @memberof HeliosEvent.TemperatureStateChanged
         * @instance
         */
        TemperatureStateChanged.prototype.value = 0;

        /**
         * Creates a new TemperatureStateChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {HeliosEvent.ITemperatureStateChanged=} [properties] Properties to set
         * @returns {HeliosEvent.TemperatureStateChanged} TemperatureStateChanged instance
         */
        TemperatureStateChanged.create = function create(properties) {
            return new TemperatureStateChanged(properties);
        };

        /**
         * Encodes the specified TemperatureStateChanged message. Does not implicitly {@link HeliosEvent.TemperatureStateChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {HeliosEvent.ITemperatureStateChanged} message TemperatureStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemperatureStateChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
            return writer;
        };

        /**
         * Encodes the specified TemperatureStateChanged message, length delimited. Does not implicitly {@link HeliosEvent.TemperatureStateChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {HeliosEvent.ITemperatureStateChanged} message TemperatureStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemperatureStateChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TemperatureStateChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.TemperatureStateChanged} TemperatureStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemperatureStateChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.TemperatureStateChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TemperatureStateChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.TemperatureStateChanged} TemperatureStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemperatureStateChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TemperatureStateChanged message.
         * @function verify
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TemperatureStateChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                switch (message.value) {
                default:
                    return "value: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a TemperatureStateChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.TemperatureStateChanged} TemperatureStateChanged
         */
        TemperatureStateChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.TemperatureStateChanged)
                return object;
            var message = new $root.HeliosEvent.TemperatureStateChanged();
            switch (object.value) {
            case "UNKNOWN_TEMP":
            case 0:
                message.value = 0;
                break;
            case "NORMAL":
            case 1:
                message.value = 1;
                break;
            case "HOT":
            case 2:
                message.value = 2;
                break;
            case "HOT_SHUTDOWN":
            case 3:
                message.value = 3;
                break;
            case "COLD_SHUTDOWN":
            case 4:
                message.value = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TemperatureStateChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.TemperatureStateChanged
         * @static
         * @param {HeliosEvent.TemperatureStateChanged} message TemperatureStateChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TemperatureStateChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = options.enums === String ? "UNKNOWN_TEMP" : 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.enums === String ? $root.TemperatureState[message.value] : message.value;
            return object;
        };

        /**
         * Converts this TemperatureStateChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.TemperatureStateChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TemperatureStateChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TemperatureStateChanged;
    })();

    HeliosEvent.BatteryStateChanged = (function() {

        /**
         * Properties of a BatteryStateChanged.
         * @memberof HeliosEvent
         * @interface IBatteryStateChanged
         * @property {BatteryState|null} [value] BatteryStateChanged value
         */

        /**
         * Constructs a new BatteryStateChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a BatteryStateChanged.
         * @implements IBatteryStateChanged
         * @constructor
         * @param {HeliosEvent.IBatteryStateChanged=} [properties] Properties to set
         */
        function BatteryStateChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BatteryStateChanged value.
         * @member {BatteryState} value
         * @memberof HeliosEvent.BatteryStateChanged
         * @instance
         */
        BatteryStateChanged.prototype.value = 0;

        /**
         * Creates a new BatteryStateChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {HeliosEvent.IBatteryStateChanged=} [properties] Properties to set
         * @returns {HeliosEvent.BatteryStateChanged} BatteryStateChanged instance
         */
        BatteryStateChanged.create = function create(properties) {
            return new BatteryStateChanged(properties);
        };

        /**
         * Encodes the specified BatteryStateChanged message. Does not implicitly {@link HeliosEvent.BatteryStateChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {HeliosEvent.IBatteryStateChanged} message BatteryStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatteryStateChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
            return writer;
        };

        /**
         * Encodes the specified BatteryStateChanged message, length delimited. Does not implicitly {@link HeliosEvent.BatteryStateChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {HeliosEvent.IBatteryStateChanged} message BatteryStateChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatteryStateChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BatteryStateChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.BatteryStateChanged} BatteryStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatteryStateChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.BatteryStateChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BatteryStateChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.BatteryStateChanged} BatteryStateChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatteryStateChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BatteryStateChanged message.
         * @function verify
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BatteryStateChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                switch (message.value) {
                default:
                    return "value: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            return null;
        };

        /**
         * Creates a BatteryStateChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.BatteryStateChanged} BatteryStateChanged
         */
        BatteryStateChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.BatteryStateChanged)
                return object;
            var message = new $root.HeliosEvent.BatteryStateChanged();
            switch (object.value) {
            case "UNKNOWN_BATTERY":
            case 0:
                message.value = 0;
                break;
            case "NORMAL_BATTERY":
            case 1:
                message.value = 1;
                break;
            case "WARNING":
            case 2:
                message.value = 2;
                break;
            case "CRITICAL":
            case 3:
                message.value = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a BatteryStateChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.BatteryStateChanged
         * @static
         * @param {HeliosEvent.BatteryStateChanged} message BatteryStateChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BatteryStateChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = options.enums === String ? "UNKNOWN_BATTERY" : 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.enums === String ? $root.BatteryState[message.value] : message.value;
            return object;
        };

        /**
         * Converts this BatteryStateChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.BatteryStateChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BatteryStateChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BatteryStateChanged;
    })();

    HeliosEvent.ModeChanged = (function() {

        /**
         * Properties of a ModeChanged.
         * @memberof HeliosEvent
         * @interface IModeChanged
         * @property {ImagingMode|null} [value] ModeChanged value
         */

        /**
         * Constructs a new ModeChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a ModeChanged.
         * @implements IModeChanged
         * @constructor
         * @param {HeliosEvent.IModeChanged=} [properties] Properties to set
         */
        function ModeChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ModeChanged value.
         * @member {ImagingMode} value
         * @memberof HeliosEvent.ModeChanged
         * @instance
         */
        ModeChanged.prototype.value = 0;

        /**
         * Creates a new ModeChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {HeliosEvent.IModeChanged=} [properties] Properties to set
         * @returns {HeliosEvent.ModeChanged} ModeChanged instance
         */
        ModeChanged.create = function create(properties) {
            return new ModeChanged(properties);
        };

        /**
         * Encodes the specified ModeChanged message. Does not implicitly {@link HeliosEvent.ModeChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {HeliosEvent.IModeChanged} message ModeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ModeChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
            return writer;
        };

        /**
         * Encodes the specified ModeChanged message, length delimited. Does not implicitly {@link HeliosEvent.ModeChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {HeliosEvent.IModeChanged} message ModeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ModeChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ModeChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.ModeChanged} ModeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ModeChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.ModeChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ModeChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.ModeChanged} ModeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ModeChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ModeChanged message.
         * @function verify
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ModeChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                switch (message.value) {
                default:
                    return "value: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            return null;
        };

        /**
         * Creates a ModeChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.ModeChanged} ModeChanged
         */
        ModeChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.ModeChanged)
                return object;
            var message = new $root.HeliosEvent.ModeChanged();
            switch (object.value) {
            case "UNKNOWN_MODE":
            case 0:
                message.value = 0;
                break;
            case "B_MODE":
            case 1:
                message.value = 1;
                break;
            case "COLOR_DOPPLER":
            case 2:
                message.value = 2;
                break;
            case "POWER_DOPPLER":
            case 3:
                message.value = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ModeChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.ModeChanged
         * @static
         * @param {HeliosEvent.ModeChanged} message ModeChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ModeChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = options.enums === String ? "UNKNOWN_MODE" : 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.enums === String ? $root.ImagingMode[message.value] : message.value;
            return object;
        };

        /**
         * Converts this ModeChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.ModeChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ModeChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ModeChanged;
    })();

    HeliosEvent.DepthChanged = (function() {

        /**
         * Properties of a DepthChanged.
         * @memberof HeliosEvent
         * @interface IDepthChanged
         * @property {number|null} [value] DepthChanged value
         */

        /**
         * Constructs a new DepthChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a DepthChanged.
         * @implements IDepthChanged
         * @constructor
         * @param {HeliosEvent.IDepthChanged=} [properties] Properties to set
         */
        function DepthChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DepthChanged value.
         * @member {number} value
         * @memberof HeliosEvent.DepthChanged
         * @instance
         */
        DepthChanged.prototype.value = 0;

        /**
         * Creates a new DepthChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {HeliosEvent.IDepthChanged=} [properties] Properties to set
         * @returns {HeliosEvent.DepthChanged} DepthChanged instance
         */
        DepthChanged.create = function create(properties) {
            return new DepthChanged(properties);
        };

        /**
         * Encodes the specified DepthChanged message. Does not implicitly {@link HeliosEvent.DepthChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {HeliosEvent.IDepthChanged} message DepthChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DepthChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
            return writer;
        };

        /**
         * Encodes the specified DepthChanged message, length delimited. Does not implicitly {@link HeliosEvent.DepthChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {HeliosEvent.IDepthChanged} message DepthChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DepthChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DepthChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.DepthChanged} DepthChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DepthChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.DepthChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DepthChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.DepthChanged} DepthChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DepthChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DepthChanged message.
         * @function verify
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DepthChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value !== "number")
                    return "value: number expected";
            return null;
        };

        /**
         * Creates a DepthChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.DepthChanged} DepthChanged
         */
        DepthChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.DepthChanged)
                return object;
            var message = new $root.HeliosEvent.DepthChanged();
            if (object.value != null)
                message.value = Number(object.value);
            return message;
        };

        /**
         * Creates a plain object from a DepthChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.DepthChanged
         * @static
         * @param {HeliosEvent.DepthChanged} message DepthChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DepthChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
            return object;
        };

        /**
         * Converts this DepthChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.DepthChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DepthChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DepthChanged;
    })();

    HeliosEvent.GainChanged = (function() {

        /**
         * Properties of a GainChanged.
         * @memberof HeliosEvent
         * @interface IGainChanged
         * @property {number|null} [value] GainChanged value
         */

        /**
         * Constructs a new GainChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a GainChanged.
         * @implements IGainChanged
         * @constructor
         * @param {HeliosEvent.IGainChanged=} [properties] Properties to set
         */
        function GainChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GainChanged value.
         * @member {number} value
         * @memberof HeliosEvent.GainChanged
         * @instance
         */
        GainChanged.prototype.value = 0;

        /**
         * Creates a new GainChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {HeliosEvent.IGainChanged=} [properties] Properties to set
         * @returns {HeliosEvent.GainChanged} GainChanged instance
         */
        GainChanged.create = function create(properties) {
            return new GainChanged(properties);
        };

        /**
         * Encodes the specified GainChanged message. Does not implicitly {@link HeliosEvent.GainChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {HeliosEvent.IGainChanged} message GainChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GainChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
            return writer;
        };

        /**
         * Encodes the specified GainChanged message, length delimited. Does not implicitly {@link HeliosEvent.GainChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {HeliosEvent.IGainChanged} message GainChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GainChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GainChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.GainChanged} GainChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GainChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.GainChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GainChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.GainChanged} GainChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GainChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GainChanged message.
         * @function verify
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GainChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value !== "number")
                    return "value: number expected";
            return null;
        };

        /**
         * Creates a GainChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.GainChanged} GainChanged
         */
        GainChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.GainChanged)
                return object;
            var message = new $root.HeliosEvent.GainChanged();
            if (object.value != null)
                message.value = Number(object.value);
            return message;
        };

        /**
         * Creates a plain object from a GainChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.GainChanged
         * @static
         * @param {HeliosEvent.GainChanged} message GainChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GainChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
            return object;
        };

        /**
         * Converts this GainChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.GainChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GainChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GainChanged;
    })();

    HeliosEvent.PresetChanged = (function() {

        /**
         * Properties of a PresetChanged.
         * @memberof HeliosEvent
         * @interface IPresetChanged
         * @property {string|null} [value] PresetChanged value
         */

        /**
         * Constructs a new PresetChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a PresetChanged.
         * @implements IPresetChanged
         * @constructor
         * @param {HeliosEvent.IPresetChanged=} [properties] Properties to set
         */
        function PresetChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PresetChanged value.
         * @member {string} value
         * @memberof HeliosEvent.PresetChanged
         * @instance
         */
        PresetChanged.prototype.value = "";

        /**
         * Creates a new PresetChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {HeliosEvent.IPresetChanged=} [properties] Properties to set
         * @returns {HeliosEvent.PresetChanged} PresetChanged instance
         */
        PresetChanged.create = function create(properties) {
            return new PresetChanged(properties);
        };

        /**
         * Encodes the specified PresetChanged message. Does not implicitly {@link HeliosEvent.PresetChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {HeliosEvent.IPresetChanged} message PresetChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PresetChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
            return writer;
        };

        /**
         * Encodes the specified PresetChanged message, length delimited. Does not implicitly {@link HeliosEvent.PresetChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {HeliosEvent.IPresetChanged} message PresetChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PresetChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PresetChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.PresetChanged} PresetChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PresetChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.PresetChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PresetChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.PresetChanged} PresetChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PresetChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PresetChanged message.
         * @function verify
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PresetChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isString(message.value))
                    return "value: string expected";
            return null;
        };

        /**
         * Creates a PresetChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.PresetChanged} PresetChanged
         */
        PresetChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.PresetChanged)
                return object;
            var message = new $root.HeliosEvent.PresetChanged();
            if (object.value != null)
                message.value = String(object.value);
            return message;
        };

        /**
         * Creates a plain object from a PresetChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.PresetChanged
         * @static
         * @param {HeliosEvent.PresetChanged} message PresetChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PresetChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = "";
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this PresetChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.PresetChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PresetChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PresetChanged;
    })();

    HeliosEvent.CameraModeChanged = (function() {

        /**
         * Properties of a CameraModeChanged.
         * @memberof HeliosEvent
         * @interface ICameraModeChanged
         * @property {CameraMode|null} [mode] CameraModeChanged mode
         * @property {number|null} [fieldOfView] CameraModeChanged fieldOfView
         */

        /**
         * Constructs a new CameraModeChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a CameraModeChanged.
         * @implements ICameraModeChanged
         * @constructor
         * @param {HeliosEvent.ICameraModeChanged=} [properties] Properties to set
         */
        function CameraModeChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CameraModeChanged mode.
         * @member {CameraMode} mode
         * @memberof HeliosEvent.CameraModeChanged
         * @instance
         */
        CameraModeChanged.prototype.mode = 0;

        /**
         * CameraModeChanged fieldOfView.
         * @member {number} fieldOfView
         * @memberof HeliosEvent.CameraModeChanged
         * @instance
         */
        CameraModeChanged.prototype.fieldOfView = 0;

        /**
         * Creates a new CameraModeChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {HeliosEvent.ICameraModeChanged=} [properties] Properties to set
         * @returns {HeliosEvent.CameraModeChanged} CameraModeChanged instance
         */
        CameraModeChanged.create = function create(properties) {
            return new CameraModeChanged(properties);
        };

        /**
         * Encodes the specified CameraModeChanged message. Does not implicitly {@link HeliosEvent.CameraModeChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {HeliosEvent.ICameraModeChanged} message CameraModeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CameraModeChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mode != null && message.hasOwnProperty("mode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.fieldOfView);
            return writer;
        };

        /**
         * Encodes the specified CameraModeChanged message, length delimited. Does not implicitly {@link HeliosEvent.CameraModeChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {HeliosEvent.ICameraModeChanged} message CameraModeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CameraModeChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CameraModeChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.CameraModeChanged} CameraModeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CameraModeChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.CameraModeChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.fieldOfView = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CameraModeChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.CameraModeChanged} CameraModeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CameraModeChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CameraModeChanged message.
         * @function verify
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CameraModeChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mode != null && message.hasOwnProperty("mode"))
                switch (message.mode) {
                default:
                    return "mode: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                if (typeof message.fieldOfView !== "number")
                    return "fieldOfView: number expected";
            return null;
        };

        /**
         * Creates a CameraModeChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.CameraModeChanged} CameraModeChanged
         */
        CameraModeChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.CameraModeChanged)
                return object;
            var message = new $root.HeliosEvent.CameraModeChanged();
            switch (object.mode) {
            case "UNKNOWN_CAMERA_MODE":
            case 0:
                message.mode = 0;
                break;
            case "FRONT":
            case 1:
                message.mode = 1;
                break;
            case "BACK":
            case 2:
                message.mode = 2;
                break;
            }
            if (object.fieldOfView != null)
                message.fieldOfView = Number(object.fieldOfView);
            return message;
        };

        /**
         * Creates a plain object from a CameraModeChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.CameraModeChanged
         * @static
         * @param {HeliosEvent.CameraModeChanged} message CameraModeChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CameraModeChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.mode = options.enums === String ? "UNKNOWN_CAMERA_MODE" : 0;
                object.fieldOfView = 0;
            }
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.CameraMode[message.mode] : message.mode;
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                object.fieldOfView = options.json && !isFinite(message.fieldOfView) ? String(message.fieldOfView) : message.fieldOfView;
            return object;
        };

        /**
         * Converts this CameraModeChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.CameraModeChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CameraModeChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CameraModeChanged;
    })();

    HeliosEvent.FreezeChanged = (function() {

        /**
         * Properties of a FreezeChanged.
         * @memberof HeliosEvent
         * @interface IFreezeChanged
         * @property {boolean|null} [frozen] FreezeChanged frozen
         * @property {boolean|null} [userTriggered] FreezeChanged userTriggered
         */

        /**
         * Constructs a new FreezeChanged.
         * @memberof HeliosEvent
         * @classdesc Represents a FreezeChanged.
         * @implements IFreezeChanged
         * @constructor
         * @param {HeliosEvent.IFreezeChanged=} [properties] Properties to set
         */
        function FreezeChanged(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FreezeChanged frozen.
         * @member {boolean} frozen
         * @memberof HeliosEvent.FreezeChanged
         * @instance
         */
        FreezeChanged.prototype.frozen = false;

        /**
         * FreezeChanged userTriggered.
         * @member {boolean} userTriggered
         * @memberof HeliosEvent.FreezeChanged
         * @instance
         */
        FreezeChanged.prototype.userTriggered = false;

        /**
         * Creates a new FreezeChanged instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {HeliosEvent.IFreezeChanged=} [properties] Properties to set
         * @returns {HeliosEvent.FreezeChanged} FreezeChanged instance
         */
        FreezeChanged.create = function create(properties) {
            return new FreezeChanged(properties);
        };

        /**
         * Encodes the specified FreezeChanged message. Does not implicitly {@link HeliosEvent.FreezeChanged.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {HeliosEvent.IFreezeChanged} message FreezeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreezeChanged.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.frozen);
            if (message.userTriggered != null && message.hasOwnProperty("userTriggered"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.userTriggered);
            return writer;
        };

        /**
         * Encodes the specified FreezeChanged message, length delimited. Does not implicitly {@link HeliosEvent.FreezeChanged.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {HeliosEvent.IFreezeChanged} message FreezeChanged message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreezeChanged.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreezeChanged message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.FreezeChanged} FreezeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreezeChanged.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.FreezeChanged();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.frozen = reader.bool();
                    break;
                case 2:
                    message.userTriggered = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreezeChanged message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.FreezeChanged} FreezeChanged
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreezeChanged.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreezeChanged message.
         * @function verify
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreezeChanged.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                if (typeof message.frozen !== "boolean")
                    return "frozen: boolean expected";
            if (message.userTriggered != null && message.hasOwnProperty("userTriggered"))
                if (typeof message.userTriggered !== "boolean")
                    return "userTriggered: boolean expected";
            return null;
        };

        /**
         * Creates a FreezeChanged message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.FreezeChanged} FreezeChanged
         */
        FreezeChanged.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.FreezeChanged)
                return object;
            var message = new $root.HeliosEvent.FreezeChanged();
            if (object.frozen != null)
                message.frozen = Boolean(object.frozen);
            if (object.userTriggered != null)
                message.userTriggered = Boolean(object.userTriggered);
            return message;
        };

        /**
         * Creates a plain object from a FreezeChanged message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.FreezeChanged
         * @static
         * @param {HeliosEvent.FreezeChanged} message FreezeChanged
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreezeChanged.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.frozen = false;
                object.userTriggered = false;
            }
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                object.frozen = message.frozen;
            if (message.userTriggered != null && message.hasOwnProperty("userTriggered"))
                object.userTriggered = message.userTriggered;
            return object;
        };

        /**
         * Converts this FreezeChanged to JSON.
         * @function toJSON
         * @memberof HeliosEvent.FreezeChanged
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreezeChanged.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreezeChanged;
    })();

    HeliosEvent.BoundedValue = (function() {

        /**
         * Properties of a BoundedValue.
         * @memberof HeliosEvent
         * @interface IBoundedValue
         * @property {number|null} [lower] BoundedValue lower
         * @property {number|null} [value] BoundedValue value
         * @property {number|null} [upper] BoundedValue upper
         */

        /**
         * Constructs a new BoundedValue.
         * @memberof HeliosEvent
         * @classdesc Represents a BoundedValue.
         * @implements IBoundedValue
         * @constructor
         * @param {HeliosEvent.IBoundedValue=} [properties] Properties to set
         */
        function BoundedValue(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BoundedValue lower.
         * @member {number} lower
         * @memberof HeliosEvent.BoundedValue
         * @instance
         */
        BoundedValue.prototype.lower = 0;

        /**
         * BoundedValue value.
         * @member {number} value
         * @memberof HeliosEvent.BoundedValue
         * @instance
         */
        BoundedValue.prototype.value = 0;

        /**
         * BoundedValue upper.
         * @member {number} upper
         * @memberof HeliosEvent.BoundedValue
         * @instance
         */
        BoundedValue.prototype.upper = 0;

        /**
         * Creates a new BoundedValue instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {HeliosEvent.IBoundedValue=} [properties] Properties to set
         * @returns {HeliosEvent.BoundedValue} BoundedValue instance
         */
        BoundedValue.create = function create(properties) {
            return new BoundedValue(properties);
        };

        /**
         * Encodes the specified BoundedValue message. Does not implicitly {@link HeliosEvent.BoundedValue.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {HeliosEvent.IBoundedValue} message BoundedValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BoundedValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lower != null && message.hasOwnProperty("lower"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.lower);
            if (message.value != null && message.hasOwnProperty("value"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.value);
            if (message.upper != null && message.hasOwnProperty("upper"))
                writer.uint32(/* id 3, wireType 5 =*/29).float(message.upper);
            return writer;
        };

        /**
         * Encodes the specified BoundedValue message, length delimited. Does not implicitly {@link HeliosEvent.BoundedValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {HeliosEvent.IBoundedValue} message BoundedValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BoundedValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BoundedValue message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.BoundedValue} BoundedValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BoundedValue.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.BoundedValue();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.lower = reader.float();
                    break;
                case 2:
                    message.value = reader.float();
                    break;
                case 3:
                    message.upper = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BoundedValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.BoundedValue} BoundedValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BoundedValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BoundedValue message.
         * @function verify
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BoundedValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lower != null && message.hasOwnProperty("lower"))
                if (typeof message.lower !== "number")
                    return "lower: number expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value !== "number")
                    return "value: number expected";
            if (message.upper != null && message.hasOwnProperty("upper"))
                if (typeof message.upper !== "number")
                    return "upper: number expected";
            return null;
        };

        /**
         * Creates a BoundedValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.BoundedValue} BoundedValue
         */
        BoundedValue.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.BoundedValue)
                return object;
            var message = new $root.HeliosEvent.BoundedValue();
            if (object.lower != null)
                message.lower = Number(object.lower);
            if (object.value != null)
                message.value = Number(object.value);
            if (object.upper != null)
                message.upper = Number(object.upper);
            return message;
        };

        /**
         * Creates a plain object from a BoundedValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.BoundedValue
         * @static
         * @param {HeliosEvent.BoundedValue} message BoundedValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BoundedValue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lower = 0;
                object.value = 0;
                object.upper = 0;
            }
            if (message.lower != null && message.hasOwnProperty("lower"))
                object.lower = options.json && !isFinite(message.lower) ? String(message.lower) : message.lower;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
            if (message.upper != null && message.hasOwnProperty("upper"))
                object.upper = options.json && !isFinite(message.upper) ? String(message.upper) : message.upper;
            return object;
        };

        /**
         * Converts this BoundedValue to JSON.
         * @function toJSON
         * @memberof HeliosEvent.BoundedValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BoundedValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BoundedValue;
    })();

    HeliosEvent.CurrentSettings = (function() {

        /**
         * Properties of a CurrentSettings.
         * @memberof HeliosEvent
         * @interface ICurrentSettings
         * @property {ImagingMode|null} [mode] CurrentSettings mode
         * @property {Array.<ImagingMode>|null} [availableModes] CurrentSettings availableModes
         * @property {string|null} [preset] CurrentSettings preset
         * @property {Array.<string>|null} [availablePresets] CurrentSettings availablePresets
         * @property {HeliosEvent.IBoundedValue|null} [gain] CurrentSettings gain
         * @property {HeliosEvent.IBoundedValue|null} [depth] CurrentSettings depth
         * @property {boolean|null} [frozen] CurrentSettings frozen
         * @property {number|null} [fieldOfView] CurrentSettings fieldOfView
         * @property {CameraMode|null} [camera] CurrentSettings camera
         * @property {ProbeState|null} [probeState] CurrentSettings probeState
         * @property {TemperatureState|null} [temperatureState] CurrentSettings temperatureState
         * @property {BatteryState|null} [batteryState] CurrentSettings batteryState
         * @property {AugmentedRealityMode|null} [augmentedRealityMode] CurrentSettings augmentedRealityMode
         * @property {HeliosEvent.IVideoDimension|null} [cameraVideoDimension] CurrentSettings cameraVideoDimension
         * @property {HeliosEvent.IVideoDimension|null} [probeVideoDimension] CurrentSettings probeVideoDimension
         * @property {HeliosEvent.ICapabilities|null} [capabilities] CurrentSettings capabilities
         * @property {boolean|null} [cameraVideoPaused] CurrentSettings cameraVideoPaused
         */

        /**
         * Constructs a new CurrentSettings.
         * @memberof HeliosEvent
         * @classdesc Represents a CurrentSettings.
         * @implements ICurrentSettings
         * @constructor
         * @param {HeliosEvent.ICurrentSettings=} [properties] Properties to set
         */
        function CurrentSettings(properties) {
            this.availableModes = [];
            this.availablePresets = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CurrentSettings mode.
         * @member {ImagingMode} mode
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.mode = 0;

        /**
         * CurrentSettings availableModes.
         * @member {Array.<ImagingMode>} availableModes
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.availableModes = $util.emptyArray;

        /**
         * CurrentSettings preset.
         * @member {string} preset
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.preset = "";

        /**
         * CurrentSettings availablePresets.
         * @member {Array.<string>} availablePresets
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.availablePresets = $util.emptyArray;

        /**
         * CurrentSettings gain.
         * @member {HeliosEvent.IBoundedValue|null|undefined} gain
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.gain = null;

        /**
         * CurrentSettings depth.
         * @member {HeliosEvent.IBoundedValue|null|undefined} depth
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.depth = null;

        /**
         * CurrentSettings frozen.
         * @member {boolean} frozen
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.frozen = false;

        /**
         * CurrentSettings fieldOfView.
         * @member {number} fieldOfView
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.fieldOfView = 0;

        /**
         * CurrentSettings camera.
         * @member {CameraMode} camera
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.camera = 0;

        /**
         * CurrentSettings probeState.
         * @member {ProbeState} probeState
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.probeState = 0;

        /**
         * CurrentSettings temperatureState.
         * @member {TemperatureState} temperatureState
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.temperatureState = 0;

        /**
         * CurrentSettings batteryState.
         * @member {BatteryState} batteryState
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.batteryState = 0;

        /**
         * CurrentSettings augmentedRealityMode.
         * @member {AugmentedRealityMode} augmentedRealityMode
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.augmentedRealityMode = 0;

        /**
         * CurrentSettings cameraVideoDimension.
         * @member {HeliosEvent.IVideoDimension|null|undefined} cameraVideoDimension
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.cameraVideoDimension = null;

        /**
         * CurrentSettings probeVideoDimension.
         * @member {HeliosEvent.IVideoDimension|null|undefined} probeVideoDimension
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.probeVideoDimension = null;

        /**
         * CurrentSettings capabilities.
         * @member {HeliosEvent.ICapabilities|null|undefined} capabilities
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.capabilities = null;

        /**
         * CurrentSettings cameraVideoPaused.
         * @member {boolean} cameraVideoPaused
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         */
        CurrentSettings.prototype.cameraVideoPaused = false;

        /**
         * Creates a new CurrentSettings instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {HeliosEvent.ICurrentSettings=} [properties] Properties to set
         * @returns {HeliosEvent.CurrentSettings} CurrentSettings instance
         */
        CurrentSettings.create = function create(properties) {
            return new CurrentSettings(properties);
        };

        /**
         * Encodes the specified CurrentSettings message. Does not implicitly {@link HeliosEvent.CurrentSettings.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {HeliosEvent.ICurrentSettings} message CurrentSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CurrentSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.mode != null && message.hasOwnProperty("mode"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
            if (message.availableModes != null && message.availableModes.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (var i = 0; i < message.availableModes.length; ++i)
                    writer.int32(message.availableModes[i]);
                writer.ldelim();
            }
            if (message.preset != null && message.hasOwnProperty("preset"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.preset);
            if (message.availablePresets != null && message.availablePresets.length)
                for (var i = 0; i < message.availablePresets.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.availablePresets[i]);
            if (message.gain != null && message.hasOwnProperty("gain"))
                $root.HeliosEvent.BoundedValue.encode(message.gain, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.depth != null && message.hasOwnProperty("depth"))
                $root.HeliosEvent.BoundedValue.encode(message.depth, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.frozen);
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                writer.uint32(/* id 8, wireType 5 =*/69).float(message.fieldOfView);
            if (message.camera != null && message.hasOwnProperty("camera"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.camera);
            if (message.probeState != null && message.hasOwnProperty("probeState"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.probeState);
            if (message.temperatureState != null && message.hasOwnProperty("temperatureState"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.temperatureState);
            if (message.augmentedRealityMode != null && message.hasOwnProperty("augmentedRealityMode"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.augmentedRealityMode);
            if (message.cameraVideoDimension != null && message.hasOwnProperty("cameraVideoDimension"))
                $root.HeliosEvent.VideoDimension.encode(message.cameraVideoDimension, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.probeVideoDimension != null && message.hasOwnProperty("probeVideoDimension"))
                $root.HeliosEvent.VideoDimension.encode(message.probeVideoDimension, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.capabilities != null && message.hasOwnProperty("capabilities"))
                $root.HeliosEvent.Capabilities.encode(message.capabilities, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.cameraVideoPaused != null && message.hasOwnProperty("cameraVideoPaused"))
                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.cameraVideoPaused);
            if (message.batteryState != null && message.hasOwnProperty("batteryState"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.batteryState);
            return writer;
        };

        /**
         * Encodes the specified CurrentSettings message, length delimited. Does not implicitly {@link HeliosEvent.CurrentSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {HeliosEvent.ICurrentSettings} message CurrentSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CurrentSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CurrentSettings message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.CurrentSettings} CurrentSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CurrentSettings.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.CurrentSettings();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    if (!(message.availableModes && message.availableModes.length))
                        message.availableModes = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.availableModes.push(reader.int32());
                    } else
                        message.availableModes.push(reader.int32());
                    break;
                case 3:
                    message.preset = reader.string();
                    break;
                case 4:
                    if (!(message.availablePresets && message.availablePresets.length))
                        message.availablePresets = [];
                    message.availablePresets.push(reader.string());
                    break;
                case 5:
                    message.gain = $root.HeliosEvent.BoundedValue.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depth = $root.HeliosEvent.BoundedValue.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.frozen = reader.bool();
                    break;
                case 8:
                    message.fieldOfView = reader.float();
                    break;
                case 9:
                    message.camera = reader.int32();
                    break;
                case 10:
                    message.probeState = reader.int32();
                    break;
                case 11:
                    message.temperatureState = reader.int32();
                    break;
                case 20:
                    message.batteryState = reader.int32();
                    break;
                case 12:
                    message.augmentedRealityMode = reader.int32();
                    break;
                case 13:
                    message.cameraVideoDimension = $root.HeliosEvent.VideoDimension.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.probeVideoDimension = $root.HeliosEvent.VideoDimension.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.capabilities = $root.HeliosEvent.Capabilities.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.cameraVideoPaused = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CurrentSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.CurrentSettings} CurrentSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CurrentSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CurrentSettings message.
         * @function verify
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CurrentSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.mode != null && message.hasOwnProperty("mode"))
                switch (message.mode) {
                default:
                    return "mode: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.availableModes != null && message.hasOwnProperty("availableModes")) {
                if (!Array.isArray(message.availableModes))
                    return "availableModes: array expected";
                for (var i = 0; i < message.availableModes.length; ++i)
                    switch (message.availableModes[i]) {
                    default:
                        return "availableModes: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
            }
            if (message.preset != null && message.hasOwnProperty("preset"))
                if (!$util.isString(message.preset))
                    return "preset: string expected";
            if (message.availablePresets != null && message.hasOwnProperty("availablePresets")) {
                if (!Array.isArray(message.availablePresets))
                    return "availablePresets: array expected";
                for (var i = 0; i < message.availablePresets.length; ++i)
                    if (!$util.isString(message.availablePresets[i]))
                        return "availablePresets: string[] expected";
            }
            if (message.gain != null && message.hasOwnProperty("gain")) {
                var error = $root.HeliosEvent.BoundedValue.verify(message.gain);
                if (error)
                    return "gain." + error;
            }
            if (message.depth != null && message.hasOwnProperty("depth")) {
                var error = $root.HeliosEvent.BoundedValue.verify(message.depth);
                if (error)
                    return "depth." + error;
            }
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                if (typeof message.frozen !== "boolean")
                    return "frozen: boolean expected";
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                if (typeof message.fieldOfView !== "number")
                    return "fieldOfView: number expected";
            if (message.camera != null && message.hasOwnProperty("camera"))
                switch (message.camera) {
                default:
                    return "camera: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.probeState != null && message.hasOwnProperty("probeState"))
                switch (message.probeState) {
                default:
                    return "probeState: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            if (message.temperatureState != null && message.hasOwnProperty("temperatureState"))
                switch (message.temperatureState) {
                default:
                    return "temperatureState: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.batteryState != null && message.hasOwnProperty("batteryState"))
                switch (message.batteryState) {
                default:
                    return "batteryState: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.augmentedRealityMode != null && message.hasOwnProperty("augmentedRealityMode"))
                switch (message.augmentedRealityMode) {
                default:
                    return "augmentedRealityMode: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.cameraVideoDimension != null && message.hasOwnProperty("cameraVideoDimension")) {
                var error = $root.HeliosEvent.VideoDimension.verify(message.cameraVideoDimension);
                if (error)
                    return "cameraVideoDimension." + error;
            }
            if (message.probeVideoDimension != null && message.hasOwnProperty("probeVideoDimension")) {
                var error = $root.HeliosEvent.VideoDimension.verify(message.probeVideoDimension);
                if (error)
                    return "probeVideoDimension." + error;
            }
            if (message.capabilities != null && message.hasOwnProperty("capabilities")) {
                var error = $root.HeliosEvent.Capabilities.verify(message.capabilities);
                if (error)
                    return "capabilities." + error;
            }
            if (message.cameraVideoPaused != null && message.hasOwnProperty("cameraVideoPaused"))
                if (typeof message.cameraVideoPaused !== "boolean")
                    return "cameraVideoPaused: boolean expected";
            return null;
        };

        /**
         * Creates a CurrentSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.CurrentSettings} CurrentSettings
         */
        CurrentSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.CurrentSettings)
                return object;
            var message = new $root.HeliosEvent.CurrentSettings();
            switch (object.mode) {
            case "UNKNOWN_MODE":
            case 0:
                message.mode = 0;
                break;
            case "B_MODE":
            case 1:
                message.mode = 1;
                break;
            case "COLOR_DOPPLER":
            case 2:
                message.mode = 2;
                break;
            case "POWER_DOPPLER":
            case 3:
                message.mode = 3;
                break;
            }
            if (object.availableModes) {
                if (!Array.isArray(object.availableModes))
                    throw TypeError(".HeliosEvent.CurrentSettings.availableModes: array expected");
                message.availableModes = [];
                for (var i = 0; i < object.availableModes.length; ++i)
                    switch (object.availableModes[i]) {
                    default:
                    case "UNKNOWN_MODE":
                    case 0:
                        message.availableModes[i] = 0;
                        break;
                    case "B_MODE":
                    case 1:
                        message.availableModes[i] = 1;
                        break;
                    case "COLOR_DOPPLER":
                    case 2:
                        message.availableModes[i] = 2;
                        break;
                    case "POWER_DOPPLER":
                    case 3:
                        message.availableModes[i] = 3;
                        break;
                    }
            }
            if (object.preset != null)
                message.preset = String(object.preset);
            if (object.availablePresets) {
                if (!Array.isArray(object.availablePresets))
                    throw TypeError(".HeliosEvent.CurrentSettings.availablePresets: array expected");
                message.availablePresets = [];
                for (var i = 0; i < object.availablePresets.length; ++i)
                    message.availablePresets[i] = String(object.availablePresets[i]);
            }
            if (object.gain != null) {
                if (typeof object.gain !== "object")
                    throw TypeError(".HeliosEvent.CurrentSettings.gain: object expected");
                message.gain = $root.HeliosEvent.BoundedValue.fromObject(object.gain);
            }
            if (object.depth != null) {
                if (typeof object.depth !== "object")
                    throw TypeError(".HeliosEvent.CurrentSettings.depth: object expected");
                message.depth = $root.HeliosEvent.BoundedValue.fromObject(object.depth);
            }
            if (object.frozen != null)
                message.frozen = Boolean(object.frozen);
            if (object.fieldOfView != null)
                message.fieldOfView = Number(object.fieldOfView);
            switch (object.camera) {
            case "UNKNOWN_CAMERA_MODE":
            case 0:
                message.camera = 0;
                break;
            case "FRONT":
            case 1:
                message.camera = 1;
                break;
            case "BACK":
            case 2:
                message.camera = 2;
                break;
            }
            switch (object.probeState) {
            case "UNKNOWN_PROBE":
            case 0:
                message.probeState = 0;
                break;
            case "CHARGING":
            case 1:
                message.probeState = 1;
                break;
            case "CONNECTED":
            case 2:
                message.probeState = 2;
                break;
            case "DISCONNECTED":
            case 3:
                message.probeState = 3;
                break;
            case "HARDWARE_INCOMPATIBLE":
            case 4:
                message.probeState = 4;
                break;
            case "FIRMWARE_INCOMPATIBLE":
            case 5:
                message.probeState = 5;
                break;
            case "NOT_READY":
            case 6:
                message.probeState = 6;
                break;
            case "READY":
            case 7:
                message.probeState = 7;
                break;
            }
            switch (object.temperatureState) {
            case "UNKNOWN_TEMP":
            case 0:
                message.temperatureState = 0;
                break;
            case "NORMAL":
            case 1:
                message.temperatureState = 1;
                break;
            case "HOT":
            case 2:
                message.temperatureState = 2;
                break;
            case "HOT_SHUTDOWN":
            case 3:
                message.temperatureState = 3;
                break;
            case "COLD_SHUTDOWN":
            case 4:
                message.temperatureState = 4;
                break;
            }
            switch (object.batteryState) {
            case "UNKNOWN_BATTERY":
            case 0:
                message.batteryState = 0;
                break;
            case "NORMAL_BATTERY":
            case 1:
                message.batteryState = 1;
                break;
            case "WARNING":
            case 2:
                message.batteryState = 2;
                break;
            case "CRITICAL":
            case 3:
                message.batteryState = 3;
                break;
            }
            switch (object.augmentedRealityMode) {
            case "UNKNOWN_AUGMENTED_REALITY_MODE":
            case 0:
                message.augmentedRealityMode = 0;
                break;
            case "FULL":
            case 1:
                message.augmentedRealityMode = 1;
                break;
            case "LOCALIZATION_ONLY":
            case 2:
                message.augmentedRealityMode = 2;
                break;
            }
            if (object.cameraVideoDimension != null) {
                if (typeof object.cameraVideoDimension !== "object")
                    throw TypeError(".HeliosEvent.CurrentSettings.cameraVideoDimension: object expected");
                message.cameraVideoDimension = $root.HeliosEvent.VideoDimension.fromObject(object.cameraVideoDimension);
            }
            if (object.probeVideoDimension != null) {
                if (typeof object.probeVideoDimension !== "object")
                    throw TypeError(".HeliosEvent.CurrentSettings.probeVideoDimension: object expected");
                message.probeVideoDimension = $root.HeliosEvent.VideoDimension.fromObject(object.probeVideoDimension);
            }
            if (object.capabilities != null) {
                if (typeof object.capabilities !== "object")
                    throw TypeError(".HeliosEvent.CurrentSettings.capabilities: object expected");
                message.capabilities = $root.HeliosEvent.Capabilities.fromObject(object.capabilities);
            }
            if (object.cameraVideoPaused != null)
                message.cameraVideoPaused = Boolean(object.cameraVideoPaused);
            return message;
        };

        /**
         * Creates a plain object from a CurrentSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.CurrentSettings
         * @static
         * @param {HeliosEvent.CurrentSettings} message CurrentSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CurrentSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.availableModes = [];
                object.availablePresets = [];
            }
            if (options.defaults) {
                object.mode = options.enums === String ? "UNKNOWN_MODE" : 0;
                object.preset = "";
                object.gain = null;
                object.depth = null;
                object.frozen = false;
                object.fieldOfView = 0;
                object.camera = options.enums === String ? "UNKNOWN_CAMERA_MODE" : 0;
                object.probeState = options.enums === String ? "UNKNOWN_PROBE" : 0;
                object.temperatureState = options.enums === String ? "UNKNOWN_TEMP" : 0;
                object.augmentedRealityMode = options.enums === String ? "UNKNOWN_AUGMENTED_REALITY_MODE" : 0;
                object.cameraVideoDimension = null;
                object.probeVideoDimension = null;
                object.capabilities = null;
                object.cameraVideoPaused = false;
                object.batteryState = options.enums === String ? "UNKNOWN_BATTERY" : 0;
            }
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = options.enums === String ? $root.ImagingMode[message.mode] : message.mode;
            if (message.availableModes && message.availableModes.length) {
                object.availableModes = [];
                for (var j = 0; j < message.availableModes.length; ++j)
                    object.availableModes[j] = options.enums === String ? $root.ImagingMode[message.availableModes[j]] : message.availableModes[j];
            }
            if (message.preset != null && message.hasOwnProperty("preset"))
                object.preset = message.preset;
            if (message.availablePresets && message.availablePresets.length) {
                object.availablePresets = [];
                for (var j = 0; j < message.availablePresets.length; ++j)
                    object.availablePresets[j] = message.availablePresets[j];
            }
            if (message.gain != null && message.hasOwnProperty("gain"))
                object.gain = $root.HeliosEvent.BoundedValue.toObject(message.gain, options);
            if (message.depth != null && message.hasOwnProperty("depth"))
                object.depth = $root.HeliosEvent.BoundedValue.toObject(message.depth, options);
            if (message.frozen != null && message.hasOwnProperty("frozen"))
                object.frozen = message.frozen;
            if (message.fieldOfView != null && message.hasOwnProperty("fieldOfView"))
                object.fieldOfView = options.json && !isFinite(message.fieldOfView) ? String(message.fieldOfView) : message.fieldOfView;
            if (message.camera != null && message.hasOwnProperty("camera"))
                object.camera = options.enums === String ? $root.CameraMode[message.camera] : message.camera;
            if (message.probeState != null && message.hasOwnProperty("probeState"))
                object.probeState = options.enums === String ? $root.ProbeState[message.probeState] : message.probeState;
            if (message.temperatureState != null && message.hasOwnProperty("temperatureState"))
                object.temperatureState = options.enums === String ? $root.TemperatureState[message.temperatureState] : message.temperatureState;
            if (message.augmentedRealityMode != null && message.hasOwnProperty("augmentedRealityMode"))
                object.augmentedRealityMode = options.enums === String ? $root.AugmentedRealityMode[message.augmentedRealityMode] : message.augmentedRealityMode;
            if (message.cameraVideoDimension != null && message.hasOwnProperty("cameraVideoDimension"))
                object.cameraVideoDimension = $root.HeliosEvent.VideoDimension.toObject(message.cameraVideoDimension, options);
            if (message.probeVideoDimension != null && message.hasOwnProperty("probeVideoDimension"))
                object.probeVideoDimension = $root.HeliosEvent.VideoDimension.toObject(message.probeVideoDimension, options);
            if (message.capabilities != null && message.hasOwnProperty("capabilities"))
                object.capabilities = $root.HeliosEvent.Capabilities.toObject(message.capabilities, options);
            if (message.cameraVideoPaused != null && message.hasOwnProperty("cameraVideoPaused"))
                object.cameraVideoPaused = message.cameraVideoPaused;
            if (message.batteryState != null && message.hasOwnProperty("batteryState"))
                object.batteryState = options.enums === String ? $root.BatteryState[message.batteryState] : message.batteryState;
            return object;
        };

        /**
         * Converts this CurrentSettings to JSON.
         * @function toJSON
         * @memberof HeliosEvent.CurrentSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CurrentSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CurrentSettings;
    })();

    HeliosEvent.VideoDimension = (function() {

        /**
         * Properties of a VideoDimension.
         * @memberof HeliosEvent
         * @interface IVideoDimension
         * @property {number|null} [width] VideoDimension width
         * @property {number|null} [height] VideoDimension height
         */

        /**
         * Constructs a new VideoDimension.
         * @memberof HeliosEvent
         * @classdesc Represents a VideoDimension.
         * @implements IVideoDimension
         * @constructor
         * @param {HeliosEvent.IVideoDimension=} [properties] Properties to set
         */
        function VideoDimension(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VideoDimension width.
         * @member {number} width
         * @memberof HeliosEvent.VideoDimension
         * @instance
         */
        VideoDimension.prototype.width = 0;

        /**
         * VideoDimension height.
         * @member {number} height
         * @memberof HeliosEvent.VideoDimension
         * @instance
         */
        VideoDimension.prototype.height = 0;

        /**
         * Creates a new VideoDimension instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {HeliosEvent.IVideoDimension=} [properties] Properties to set
         * @returns {HeliosEvent.VideoDimension} VideoDimension instance
         */
        VideoDimension.create = function create(properties) {
            return new VideoDimension(properties);
        };

        /**
         * Encodes the specified VideoDimension message. Does not implicitly {@link HeliosEvent.VideoDimension.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {HeliosEvent.IVideoDimension} message VideoDimension message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VideoDimension.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.width != null && message.hasOwnProperty("width"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.width);
            if (message.height != null && message.hasOwnProperty("height"))
                writer.uint32(/* id 2, wireType 5 =*/21).float(message.height);
            return writer;
        };

        /**
         * Encodes the specified VideoDimension message, length delimited. Does not implicitly {@link HeliosEvent.VideoDimension.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {HeliosEvent.IVideoDimension} message VideoDimension message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VideoDimension.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VideoDimension message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.VideoDimension} VideoDimension
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VideoDimension.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.VideoDimension();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.width = reader.float();
                    break;
                case 2:
                    message.height = reader.float();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VideoDimension message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.VideoDimension} VideoDimension
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VideoDimension.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VideoDimension message.
         * @function verify
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VideoDimension.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.width != null && message.hasOwnProperty("width"))
                if (typeof message.width !== "number")
                    return "width: number expected";
            if (message.height != null && message.hasOwnProperty("height"))
                if (typeof message.height !== "number")
                    return "height: number expected";
            return null;
        };

        /**
         * Creates a VideoDimension message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.VideoDimension} VideoDimension
         */
        VideoDimension.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.VideoDimension)
                return object;
            var message = new $root.HeliosEvent.VideoDimension();
            if (object.width != null)
                message.width = Number(object.width);
            if (object.height != null)
                message.height = Number(object.height);
            return message;
        };

        /**
         * Creates a plain object from a VideoDimension message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.VideoDimension
         * @static
         * @param {HeliosEvent.VideoDimension} message VideoDimension
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VideoDimension.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.width = 0;
                object.height = 0;
            }
            if (message.width != null && message.hasOwnProperty("width"))
                object.width = options.json && !isFinite(message.width) ? String(message.width) : message.width;
            if (message.height != null && message.hasOwnProperty("height"))
                object.height = options.json && !isFinite(message.height) ? String(message.height) : message.height;
            return object;
        };

        /**
         * Converts this VideoDimension to JSON.
         * @function toJSON
         * @memberof HeliosEvent.VideoDimension
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VideoDimension.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VideoDimension;
    })();

    HeliosEvent.Capabilities = (function() {

        /**
         * Properties of a Capabilities.
         * @memberof HeliosEvent
         * @interface ICapabilities
         * @property {boolean|null} [magicMarkerCamera] Capabilities magicMarkerCamera
         * @property {boolean|null} [ghostProbe] Capabilities ghostProbe
         * @property {boolean|null} [magicMarkerProbe] Capabilities magicMarkerProbe
         * @property {boolean|null} [correctProbeFeedColor] Capabilities correctProbeFeedColor
         * @property {boolean|null} [multiAxisTilts] Capabilities multiAxisTilts
         * @property {number|null} [augmentedRealityOverlayVersion] Capabilities augmentedRealityOverlayVersion
         * @property {boolean|null} [fieldOfViewCorrectedOnHelios] Capabilities fieldOfViewCorrectedOnHelios
         */

        /**
         * Constructs a new Capabilities.
         * @memberof HeliosEvent
         * @classdesc Represents a Capabilities.
         * @implements ICapabilities
         * @constructor
         * @param {HeliosEvent.ICapabilities=} [properties] Properties to set
         */
        function Capabilities(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Capabilities magicMarkerCamera.
         * @member {boolean} magicMarkerCamera
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.magicMarkerCamera = false;

        /**
         * Capabilities ghostProbe.
         * @member {boolean} ghostProbe
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.ghostProbe = false;

        /**
         * Capabilities magicMarkerProbe.
         * @member {boolean} magicMarkerProbe
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.magicMarkerProbe = false;

        /**
         * Capabilities correctProbeFeedColor.
         * @member {boolean} correctProbeFeedColor
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.correctProbeFeedColor = false;

        /**
         * Capabilities multiAxisTilts.
         * @member {boolean} multiAxisTilts
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.multiAxisTilts = false;

        /**
         * Capabilities augmentedRealityOverlayVersion.
         * @member {number} augmentedRealityOverlayVersion
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.augmentedRealityOverlayVersion = 0;

        /**
         * Capabilities fieldOfViewCorrectedOnHelios.
         * @member {boolean} fieldOfViewCorrectedOnHelios
         * @memberof HeliosEvent.Capabilities
         * @instance
         */
        Capabilities.prototype.fieldOfViewCorrectedOnHelios = false;

        /**
         * Creates a new Capabilities instance using the specified properties.
         * @function create
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {HeliosEvent.ICapabilities=} [properties] Properties to set
         * @returns {HeliosEvent.Capabilities} Capabilities instance
         */
        Capabilities.create = function create(properties) {
            return new Capabilities(properties);
        };

        /**
         * Encodes the specified Capabilities message. Does not implicitly {@link HeliosEvent.Capabilities.verify|verify} messages.
         * @function encode
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {HeliosEvent.ICapabilities} message Capabilities message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Capabilities.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.magicMarkerCamera != null && message.hasOwnProperty("magicMarkerCamera"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.magicMarkerCamera);
            if (message.ghostProbe != null && message.hasOwnProperty("ghostProbe"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.ghostProbe);
            if (message.magicMarkerProbe != null && message.hasOwnProperty("magicMarkerProbe"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.magicMarkerProbe);
            if (message.correctProbeFeedColor != null && message.hasOwnProperty("correctProbeFeedColor"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.correctProbeFeedColor);
            if (message.multiAxisTilts != null && message.hasOwnProperty("multiAxisTilts"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.multiAxisTilts);
            if (message.augmentedRealityOverlayVersion != null && message.hasOwnProperty("augmentedRealityOverlayVersion"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.augmentedRealityOverlayVersion);
            if (message.fieldOfViewCorrectedOnHelios != null && message.hasOwnProperty("fieldOfViewCorrectedOnHelios"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.fieldOfViewCorrectedOnHelios);
            return writer;
        };

        /**
         * Encodes the specified Capabilities message, length delimited. Does not implicitly {@link HeliosEvent.Capabilities.verify|verify} messages.
         * @function encodeDelimited
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {HeliosEvent.ICapabilities} message Capabilities message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Capabilities.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Capabilities message from the specified reader or buffer.
         * @function decode
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {HeliosEvent.Capabilities} Capabilities
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Capabilities.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeliosEvent.Capabilities();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.magicMarkerCamera = reader.bool();
                    break;
                case 2:
                    message.ghostProbe = reader.bool();
                    break;
                case 3:
                    message.magicMarkerProbe = reader.bool();
                    break;
                case 4:
                    message.correctProbeFeedColor = reader.bool();
                    break;
                case 5:
                    message.multiAxisTilts = reader.bool();
                    break;
                case 6:
                    message.augmentedRealityOverlayVersion = reader.int32();
                    break;
                case 7:
                    message.fieldOfViewCorrectedOnHelios = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Capabilities message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {HeliosEvent.Capabilities} Capabilities
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Capabilities.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Capabilities message.
         * @function verify
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Capabilities.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.magicMarkerCamera != null && message.hasOwnProperty("magicMarkerCamera"))
                if (typeof message.magicMarkerCamera !== "boolean")
                    return "magicMarkerCamera: boolean expected";
            if (message.ghostProbe != null && message.hasOwnProperty("ghostProbe"))
                if (typeof message.ghostProbe !== "boolean")
                    return "ghostProbe: boolean expected";
            if (message.magicMarkerProbe != null && message.hasOwnProperty("magicMarkerProbe"))
                if (typeof message.magicMarkerProbe !== "boolean")
                    return "magicMarkerProbe: boolean expected";
            if (message.correctProbeFeedColor != null && message.hasOwnProperty("correctProbeFeedColor"))
                if (typeof message.correctProbeFeedColor !== "boolean")
                    return "correctProbeFeedColor: boolean expected";
            if (message.multiAxisTilts != null && message.hasOwnProperty("multiAxisTilts"))
                if (typeof message.multiAxisTilts !== "boolean")
                    return "multiAxisTilts: boolean expected";
            if (message.augmentedRealityOverlayVersion != null && message.hasOwnProperty("augmentedRealityOverlayVersion"))
                if (!$util.isInteger(message.augmentedRealityOverlayVersion))
                    return "augmentedRealityOverlayVersion: integer expected";
            if (message.fieldOfViewCorrectedOnHelios != null && message.hasOwnProperty("fieldOfViewCorrectedOnHelios"))
                if (typeof message.fieldOfViewCorrectedOnHelios !== "boolean")
                    return "fieldOfViewCorrectedOnHelios: boolean expected";
            return null;
        };

        /**
         * Creates a Capabilities message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {HeliosEvent.Capabilities} Capabilities
         */
        Capabilities.fromObject = function fromObject(object) {
            if (object instanceof $root.HeliosEvent.Capabilities)
                return object;
            var message = new $root.HeliosEvent.Capabilities();
            if (object.magicMarkerCamera != null)
                message.magicMarkerCamera = Boolean(object.magicMarkerCamera);
            if (object.ghostProbe != null)
                message.ghostProbe = Boolean(object.ghostProbe);
            if (object.magicMarkerProbe != null)
                message.magicMarkerProbe = Boolean(object.magicMarkerProbe);
            if (object.correctProbeFeedColor != null)
                message.correctProbeFeedColor = Boolean(object.correctProbeFeedColor);
            if (object.multiAxisTilts != null)
                message.multiAxisTilts = Boolean(object.multiAxisTilts);
            if (object.augmentedRealityOverlayVersion != null)
                message.augmentedRealityOverlayVersion = object.augmentedRealityOverlayVersion | 0;
            if (object.fieldOfViewCorrectedOnHelios != null)
                message.fieldOfViewCorrectedOnHelios = Boolean(object.fieldOfViewCorrectedOnHelios);
            return message;
        };

        /**
         * Creates a plain object from a Capabilities message. Also converts values to other types if specified.
         * @function toObject
         * @memberof HeliosEvent.Capabilities
         * @static
         * @param {HeliosEvent.Capabilities} message Capabilities
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Capabilities.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.magicMarkerCamera = false;
                object.ghostProbe = false;
                object.magicMarkerProbe = false;
                object.correctProbeFeedColor = false;
                object.multiAxisTilts = false;
                object.augmentedRealityOverlayVersion = 0;
                object.fieldOfViewCorrectedOnHelios = false;
            }
            if (message.magicMarkerCamera != null && message.hasOwnProperty("magicMarkerCamera"))
                object.magicMarkerCamera = message.magicMarkerCamera;
            if (message.ghostProbe != null && message.hasOwnProperty("ghostProbe"))
                object.ghostProbe = message.ghostProbe;
            if (message.magicMarkerProbe != null && message.hasOwnProperty("magicMarkerProbe"))
                object.magicMarkerProbe = message.magicMarkerProbe;
            if (message.correctProbeFeedColor != null && message.hasOwnProperty("correctProbeFeedColor"))
                object.correctProbeFeedColor = message.correctProbeFeedColor;
            if (message.multiAxisTilts != null && message.hasOwnProperty("multiAxisTilts"))
                object.multiAxisTilts = message.multiAxisTilts;
            if (message.augmentedRealityOverlayVersion != null && message.hasOwnProperty("augmentedRealityOverlayVersion"))
                object.augmentedRealityOverlayVersion = message.augmentedRealityOverlayVersion;
            if (message.fieldOfViewCorrectedOnHelios != null && message.hasOwnProperty("fieldOfViewCorrectedOnHelios"))
                object.fieldOfViewCorrectedOnHelios = message.fieldOfViewCorrectedOnHelios;
            return object;
        };

        /**
         * Converts this Capabilities to JSON.
         * @function toJSON
         * @memberof HeliosEvent.Capabilities
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Capabilities.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Capabilities;
    })();

    return HeliosEvent;
})();

module.exports = $root;
